// Global settings
//

// Enviroment
window.enviroment = 'auto'; // 'dev', 'live', 'auto'
window.errorMode = 'silent';

// Template
window.breakpoints = ['xs', 'sm',  'md', 'lg', 'xl', 'xxl'];
window.breakpoint = null;

window.lastScrollPosition = 0;
window.lastScrollDirectionChangePosition = 0;
window.lastScrollDirection = 'down';
window.scrollOffset = 0;
window.headerHeight = 0;
window.headerScrollOffset = 0;
window.windowWidth = 0;
window.windowHeight = 0;

// Language
//

// Mapping
//
window.languages = {
	de: 'deu',
	it: 'ita',
	en: 'eng'
};

// Typo3
window.languagesTypo3 = {
	de: '0',
	it:	'2',
	en: '1'
};

// Detection
//
if (typeof window.lang === 'undefined') {
	window.la = window.document.location.href.split('/');la = la[la.length-2];
	window.lang = languages[la];
} else if (typeof window.la === 'undefined') {
	for (let i in window.languages) 	{
		if (window.languages[i] === window.lang) {
			window.la = i;
		}
	}
}

// Strings
window.strings = {
	show: {
		deu: 'anzeigen',
		eng: 'show',
		ita: 'mostra',
	},
	hide: {
		deu: 'ausblenden',
		eng: 'hide',
		ita: 'nascondere',
	},
	readmore: {
		deu: 'Mehr anzeigen',
		eng: 'show more',
		ita: 'mostra piú',
	},
	readless: {
		deu: 'Weniger anzeigen',
		eng: 'show less',
		ita: 'mostra di meno',
	},
	night: {
		deu: 'Nacht',
		eng: 'night',
		ita: 'notte',
	},
	nights: {
		deu: 'Nächte',
		eng: 'nights',
		ita: 'notti',
	},
	photo: {
		deu: 'Foto',
		eng: 'photo',
		ita: 'foto',
	},
	photos: {
		deu: 'Fotos',
		eng: 'photos',
		ita: 'foto',
	},
	swiperPrevSlide: {
		deu: 'Vorherige Slide',
		eng: 'Previous slide',
		ita: 'Slide precedente',
	},
	swiperNextSlide: {
		deu: 'Nächste Slide',
		eng: 'Next slide',
		ita: 'Slide successiva',
	},
	swiperFirstSlide: {
		deu: 'Dies ist die erste Slide',
		eng: 'This is the first slide',
		ita: 'Questa è la prima slide',
	},
	swiperLastSlide: {
		deu: 'Dies ist die letzte Slide',
		eng: 'This is the last slide',
		ita: 'Questa è l’ultima slide',
	},
	swiperPaginationBullet: {
		deu: 'Gehe zu Slide {{index}}',
		eng: 'Go to slide {{index}}',
		ita: 'Vai alla slide {{index}}',
	},
	swiperSlideLabel: {
		deu: '{{index}} / {{slidesLength}}',
		eng: '{{index}} / {{slidesLength}}',
		ita: '{{index}} / {{slidesLength}}',
	},
	swiperContainerMessage: {
		deu: 'Slider',
		eng: 'Slider',
		ita: 'Slider',
	},
	swiperContainerRoleDescription: {
		deu: 'Karussell',
		eng: 'Carousel',
		ita: 'Carosello',
	},
	swiperItemRoleDescription: {
		deu: 'Slide',
		eng: 'Slide',
		ita: 'Slide',
	},
}

// Block iFrame
if (window.top != self) {
	var host = '';
	try {
		host = window.top.location.host; // can throw an error
	} catch(e) {
	}

	if(host == '') {
		host = window.document.referrer;
	}

	if(typeof ignoreIframeBreaker !== 'undefined' && ignoreIframeBreaker === true) {
		setCookie('ignoreIframeBreaker', 'true');
	} else if(getCookie('ignoreIframeBreaker') !== 'true' && host !== 'www.valgardena.it' && host.indexOf('virtual.valgardena.it') === -1) { //  && top.location.host !== 'www.valgardena.it' // ausnahme für virtual.valgardena.it, doppelt verschachtelte IFrames
		try {
			window.top.location = window.self.location;
		} catch (ex) {
			console.log(ex);
		}
	}
}

// Detect enviroment
if (typeof enviroment !== 'undefined' && enviroment === 'auto') {
	window.enviroment = detectEnviroment();
}

// Consent Tool
window.consentTool = 'auto'; // 'gnConsent', 'auto', 'custom'
window.consentToolActive = false; // true, false, 'auto'
if (typeof gnConsent !== 'undefined' && window.consentTool === 'auto') {
	window.consentTool = 'gnConsent';
	window.consentToolActive = true;
}

// Init
//

window.youtubeApiLoaded = false;
window.vimeoApiLoaded = false;

function init() {
	if (window.enviroment === 'dev') {
		console.info('init');
	}

	// General
	//

	// Breakpoint
	window.breakpoint = detectBreakpoint();

	// Layout
	//

	// Window height
	window.windowHeight = $(window).height();

	// Header height
	if ($('#header').length > 0) {
		window.headerHeight = $('#header').outerHeight();
	}

	// Header scroll offset
	if ($('#contentcontainer').find('.best-price-badge').length > 0 && $('.headertop').find('.best-price-badge').length > 0) {
		window.headerScrollOffset = $('#contentcontainer').find('.best-price-badge').first().offset().top;
	}
	/*
	else if ($('body').hasClass('cover')) {
		window.headerScrollOffset = window.headerHeight;
	}
	*/
	else if ($('body').hasClass('noheader')) {
		window.headerScrollOffset = 100;
	} else {
		window.headerScrollOffset = window.headerHeight / 3;
	}

	// Menus
	//

	// Fullscreen menu
	//

	// Init
	$('.fullscreenmenu').each(function() {
		try {
			const el = $(this);
			const elId = $(this).attr('id');
			const toggle = $('.fullscreenmenu-toggle[data-toggle="#' + elId + '"]');
			if ($(el).hasClass('is-open')) {
				openFullscreenMenuWithPriority(el, toggle);
			} else {
				closeFullscreenMenu(el, toggle);
				closeMenu();
			}
		} catch (e) {
			console.warn('Exception in fullscreenmenu', e);
		}
	});

	// Toggle
	$('.fullscreenmenu-toggle').click(function(e) {
		e.preventDefault();

		try {
			const el = $(this).attr('data-toggle');
			const elId = $(el).attr('id');
			const toggle = $('.fullscreenmenu-toggle[data-toggle="#' + elId + '"]');
			if ($(el).hasClass('is-open')) {
				closeFullscreenMenu(el, toggle);
				closeMenu();
			} else {
				openFullscreenMenuWithPriority(el, toggle);
			}
		} catch (e) {
			console.warn('Exception in fullscreenmenu-toggle', e);
		}
	});

	// Close menu on escape
	$(document).keyup(function(e) {
		if(e.key === "Escape") { // escape key maps to keycode `27`
			closeMenu();
			closeAllOpenFullscreenMenus();
			closeAllMainNavItems();
		}
	});

	// Navigation
	//

	// Auto scroll (if anchor has hash to a existing content element)
	$('a[href*="#c"]:not([href^="javascript:"])').bind('click', function (e) {
		let href = $(this).attr('href');
		href = href.split('#c');
		href = href[1];
		if($('#ce' + href).length > 0) {
			scrollToElement($('#ce' + href));
		} else {
			return true;
		}
	});


	// Main nav
	$('.mainnav').each(function () {
		const elem = $(this);
		const firstLayer = $(elem).find('nav > ul > li');

		if ($(elem).hasClass('dropdown-nav')) {
			// Open menu control
			$(firstLayer).has('.outer-container').find('> a').each(function () {
				$(this).click(function (e) {
					e.preventDefault();

					const anchorEl = $(this);
					if ($(anchorEl).closest('li').hasClass('is-open')) {
						//$(this).closest('li').removeClass('is-open');

						closeAllMainNavItems();
						closeMenu();
					} else {
						openMainNavItem(anchorEl);
						openMenu(0);
					}
				});
			});

			recalcDropdownMenuMinHeight(elem, firstLayer, 100);

			// Add hover effect
			$(firstLayer).has('.mainnavimages').find('.outer-container > .outer-item > ul > li:not(.mainnavimages)').on('mouseenter', function () {
				const uid = $(this).attr('data-uid');
				//const pid = $(this).attr('data-pid');
				const mainnavimages = $(this).closest('ul').find('.mainnavimages').first();

				$(mainnavimages).find('li.hover').each(function () {
					if ($(this).attr('data-uid') !== uid) {
						$(this).removeClass('hover');
					}
				});

				$(mainnavimages).find('li[data-uid="' + uid + '"]').addClass('hover');
			}).on('mouseleave', function () {
				const mainnavimages = $(this).closest('ul').find('.mainnavimages').first();

				$(mainnavimages).find('li.hover').removeClass('hover');
			});

		} else if ($(elem).hasClass('drilldown-nav')) {
			// Logic on elements with sublayer
			const drilldownListItems = $(elem).find('li:has(> .drilldown-layer)');
			$(drilldownListItems).each(function () {
				const drilldownListItem = $(this);

				// Append arrow if not exist (Only for necessary ones)
				$(drilldownListItem).find('> a').each(function () {
					$(this).addClass('drilldown-toggle');
					if ($(this).find('[class*="icon-arrow"]').length <= 0) {
						$(this).append('<span class="icon-arrow-right-small"></span>');
					}
				});

				// Add open click event
				const drillToggle = $(drilldownListItem).find('.drilldown-toggle');
				//const drillToggle = $(drilldownListItem).find('a');
				$(drillToggle).on('click', function (e) {
					e.preventDefault();
					$(drilldownListItem).addClass('is-open');
				});

				// Back link
				const drillBack = $(drilldownListItem).find('.drilldown-back');
				$(drillBack).off('click.drillback').on('click.drillback', function (e) {
					e.preventDefault();
					$(drilldownListItem).removeClass('is-open');
				});
			});
		}

		$(this).addClass('init');
	});


	// Drilldown
	// Close
	$('.drilldown-close').click(function(e) {
		e.preventDefault();

		try {
			const closeBtn = $(this);
			let drilldownNav = $(closeBtn).attr('data-drilldown');
			if (!drilldownNav && $(drilldownNav).length <= 0) {
				drilldownNav = $(closeBtn).closest('.drilldown-nav');
			}
			const openElements = $(drilldownNav).find('li.is-open');
			$(openElements).removeClass('is-open');
		} catch (e) {
			// Fail silently
		}
	});

	// Content
	//

	// Custom checkbox
	$('.customcheckbox input[type="checkbox"], .customcheckboxgroup input[type="checkbox"]').change(function() {
		if($(this).prop('checked') === true) {
			$(this).parent().addClass('checked');
		} else {
			$(this).parent().removeClass('checked');
		}
		if(typeof $(this).attr('data-passto') !== 'undefined' && $('input[name="'+ $(this).attr('data-passto')+'"]').length > 0) {
			if($(this).prop('checked') === true) {
				$('input[name="'+ $(this).attr('data-passto')+'"]').val('1');
			} else {
				$('input[name="'+ $(this).attr('data-passto')+'"]').val('');
			}
		}
		customCheckboxCallback(this);
	});
	$('.customcheckbox input[type="checkbox"]').trigger('change');

	// Group
	$('.customcheckboxgroup input[type="checkbox"]').each(function () {
		initCheckbox($(this));
	});

	// Scroll
	// @todo: is this neccessary?
	//scroll();
}

// Load (Document ready)
//

window.bLazy = null;
function load(box = document.body) {
	if (enviroment === 'dev') {
		console.log('load');
	}

	// General
	//

	// Breakpoint
	// @todo: is this necessary? exist also in init function!
	//window.breakpoint = detectBreakpoint();

	// Blazy
	if (typeof Blazy !== 'undefined') {
		const breakpoints = [
			{ width: 420,  src: 'data-src-xs', ratio: 'data-ratio-xs' },
			{ width: 640,  src: 'data-src-sm', ratio: 'data-ratio-sm' },
			{ width: 1080, src: 'data-src-md', ratio: 'data-ratio-md' },
			{ width: 1440, src: 'data-src-lg', ratio: 'data-ratio-lg' }
		];

		const elements = box.querySelectorAll('.b-lazy');
		const currentScreenWidth = window.innerWidth || screen.width;

		const updates = [];

		for (let i = 0; i < elements.length; i++) {
			const elem = elements[i];
			let chosenRatioAttr = false;

			for (let j = 0; j < breakpoints.length; j++) {
				const bp = breakpoints[j];
				if (bp.width >= currentScreenWidth) {
					const attrValue = elem.getAttribute(bp.ratio);
					if (attrValue && attrValue.includes('x')) {
						chosenRatioAttr = attrValue;
						break;
					}
				}
			}

			if (chosenRatioAttr) {
				const imgRatio = chosenRatioAttr.split('x');
				const width = imgRatio[0];
				const height = imgRatio[1];
				const svgData = `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${width} ${height}' width='${width}' height='${height}'></svg>`;

				updates.push({ elem, svgData });
			}
		}

		requestAnimationFrame(() => {
			for (let i = 0; i < updates.length; i++) {
				updates[i].elem.setAttribute('src', updates[i].svgData);
			}

			window.bLazy = new Blazy({
				breakpoints: breakpoints,
				success: function(element) {
					setTimeout(function() {
						element.classList.remove('b-lazy');
						if (element.parentNode) {
							element.parentNode.classList.remove('childLoading');
						}
					}, 200);
				},
				error: function(elem, msg) {
					if (typeof enviroment !== 'undefined' && enviroment === 'dev') {
						if (msg === 'missing') {
							console.warn(elem, 'data-src is missing');
						} else if (msg === 'invalid') {
							elem.removeAttribute('data-src');
						}
					}
				}
			});
		});
	}

	// Layout
	//

	// Slide switch
	gridSlideSwitch(true);

	// Tabs
	initTabs($('.tabs-container', box));

	// Init tab nav slider
	if (typeof(initTabNavigationSlider) !== 'undefined' && $('.tabs-navigation:has(.swiper-container)', box).length > 0) {
		$('.tabs-navigation:has(.swiper-container)', box).each(function () {
			initTabNavigationSlider($(this));
		});
	}

	// Headermedia
	if ($('#headermedia').length > 0) {
		const elem = $('#headermedia', box);
		const config = {
			effect: 'fade',
			autoplay: {
				delay: 4000,
				disableOnInteraction: true,
			},
			loop: false,
			rewind: true,
			filterHiddenSlides: true,
		}
		let headermedia = new Slider(elem, config);
	}

	// Search form
	$('.searchbtn', box).click(function(event) {
		let form = $('body').find('.search-form');
		$(form).each(function () {
			$(this).addClass('visible').find('input').eq(0).each(function () {
				$(this).keyup(function(e) {
					if(e.key === "Escape") {
						$(form).removeClass('visible');
					}
				});
			})//.focus();
		});
		let currentForm = $(this).closest('[class*="container"]').find('.search-form').eq(0);
		if ($(currentForm).hasClass('visible')) {
			$(currentForm).find('input').eq(0).focus();
		}
	});

	// Content
	//

	// Dropdown
	//Dropdown.init(box, true);


	// Articles

	// Vievport animation
	$('.viewport').addClass('viewport-initialized');

	// Articlestandard mediaslider
	if ($('.articlestandard .articlemedia:has(.swiper-container)', box).length > 0) {
		const config = {
			autoplay: false,
			loop: true,
			preventClicks: false,
			preventClicksPropagation: false,
		};
		$('.articlestandard .articlemedia:has(.swiper-container)', box).each(function () {
			let articlestandard = new Slider($(this), config);
		});
	}

	// Articleteaser
	if ($('.articleteaser.fullscreen-teaser:has(.swiper-slide.teaser-item)', box).length > 0) {
		$('.articleteaser.fullscreen-teaser:has(.swiper-slide.teaser-item)', box).each(function () {
			// init thumb slider
			// @todo: optimize maxSlidesPerView
			const thumbConfig = {
				watchSlidesProgress: true,
				maxSlidesPerView: 4.5,
			};
			let teaserThumb = new Slider($(this).find('.outer-container .outer-item.thumb'), thumbConfig);

			// init teaser slider
			const teaserConfig = {
				autoplay: false,
				loop: true,
				spaceBetween: 0,
				effect: 'fade',
				navigation: {
					nextEl: $(this).find('.swiper-button-next').first().get(0),
					prevEl: $(this).find('.swiper-button-prev').first().get(0),
				},
				pagination: {
					el: $(this).find('.swiper-pagination').get(0),
					type: 'fraction',
					renderFraction: function (currentClass, totalClass) {
						return '<div class="d-flex flex-row">' +
							'	<div class="swiper-pagination-current flex-grow-1 text-end ' + currentClass + '"></div>' +
							'	<div class="swiper-pagination-seperator">&nbsp;/&nbsp;</div>' +
							'	<div class="swiper-pagination-total  flex-grow-1 text-start ' + totalClass + '"></div>' +
							'</div>';
					}
				},
				thumbs: {
					swiper: teaserThumb.slider,
				}
			};
			let teaserSlider = new Slider($(this).find('.outer-container .outer-item.slider'), teaserConfig);
		});
	}

	// Articlecard slider
	$('.articlecard.slider-card', box).each(function () {
		const config = {
			autoplay: false,
			// use desktop first when loop schould be enabled (because of swiper restriction for loop and amount of slides. get more infos in Slider function)
			loop: false,
			//rewind: true,
			slidesPerView: 1.1,
			slidesPerGroup: 1,
			spaceBetween: 20,
			grabCursor: true,
			lazyPreloadPrevNext: 2,
			breakpoints: {
				1441: {
					slidesPerView: 3.56,
					spaceBetween: 60,
				},
				1281: {
					slidesPerView: 3.56,
					spaceBetween: 40,
				},
				1081: {
					slidesPerView: 3.36,
					spaceBetween: 40,
				},
				962: {
					slidesPerView: 3.1,
					spaceBetween: 30,
				},
				801: {
					slidesPerView: 2.51,
					spaceBetween: 30,
				},
				641: {
					slidesPerView: 2.1,
					spaceBetween: 30,
				},
				421: {
					slidesPerView: 1.4,
					spaceBetween: 20,
				},
			},
			scrollbar: {
				el: $(this).find('.swiper-scrollbar').get(0),
				draggable: true,
				enabled: true,
			},
			navigation: {
				nextEl: $(this).find('.swiper-button-next').first().get(0),
				prevEl: $(this).find('.swiper-button-prev').first().get(0),
			},
			pagination: {
				el: $(this).find('.swiper-pagination').get(0),
				type: 'fraction',
				/*
				formatFractionCurrent: function (number) {
					return prependZero(number);
				},
				formatFractionTotal: function (number) {
					return prependZero(number);
				},
				*/
				renderFraction: function (currentClass, totalClass) {
					return '<div class="d-flex flex-row">' +
						'	<div class="swiper-pagination-current flex-grow-1 text-end ' + currentClass + '"></div>' +
						'	<div class="swiper-pagination-seperator">&nbsp;/&nbsp;</div>' +
						'	<div class="swiper-pagination-total  flex-grow-1 text-start ' + totalClass + '"></div>' +
						'</div>';
				}
			},
		};

		let cardSlider = new Slider($(this), config);
	});

	// Articlesearch
	//

	// Calc offset
	calcArticleSearchOffset();

	// Height observer
	initArticleSearchHeightObserver();

	// Slide view
	if (typeof window.initSearchSlider === 'function') {
		$($('.articlesearch', box).find('.article-container.swiper-container')).each(function () {
			window.initSearchSlider($(this));
		});
	}

	// Search item
	const searchItems = $('.search-item', box).toArray();
	initSearchItemSlider(searchItems);

	// Articledetail
	$('.articledetail .slider', box).each(function () {
		const config = {
			autoplay: false,
			loop: true,
			navigation: {
				nextEl: $(this).find('.swiper-button-next').first().get(0),
				prevEl: $(this).find('.swiper-button-prev').first().get(0),
			},
			pagination: {
				el: $(this).find('.swiper-pagination').get(0),
				type: 'fraction',
				renderFraction: function (currentClass, totalClass) {
					return '<div class="d-flex flex-row">' +
						'	<div class="swiper-pagination-current flex-grow-1 text-end ' + currentClass + '"></div>' +
						'	<div class="swiper-pagination-seperator">&nbsp;/&nbsp;</div>' +
						'	<div class="swiper-pagination-total  flex-grow-1 text-start ' + totalClass + '"></div>' +
						'</div>';
				}
			},
		};

		let articleDetailSlider = new Slider($(this), config);
	});


	// Thumbnail-slider
	//

	if (typeof window.initThumbnailSlider === 'function') {
		$('.thumbnail-slider', box).each(function () {
			window.initThumbnailSlider($(this));
		});
	}


	// Articlegallery grid video
	if ($('.articlegallery.grid', box).find('.video').length > 0) {
		$('.articlegallery.grid', box).find('.video').each(function () {
			Video.init($(this));
		});
	}

	// Count-up
	$('[data-count-up]', box).each(function () {
		const countItem = $(this);
		const triggerElement = $(countItem).closest('.viewport');
		if (typeof triggerElement === 'undefined' || $(triggerElement).length <= 0) {
			return;
		}
		const countTo = $(countItem).attr('data-count-up');
		const duration = 2000;

		if ($(triggerElement).hasClass('is-in-viewport')) {
			countUp($(countItem), countTo, duration);
		}

		onClassChange($(triggerElement), function ($elem) {
			if ($elem.hasClass('is-in-viewport')) {
				setTimeout(function () {
					countUp($(countItem), countTo, duration);
				}, 100);
			}
		});
	});

	// Image Maps mitskalieren
	if ($('img[usemap]').length > 0) {
		if ($().mapster) {
			$('img[usemap]').mapster({
				stroke: false,
				fill: false,
				onClick: function () {
					return true;
				}
			});
		}
	}

	// Scroll
	scroll(box);

	// Resize
	resize(true, true, box);

	// Anchor (hash) autoscroll
	if (window.location.hash.indexOf('#c') != -1) {
		let href = window.location.href.split('#c');
		// timeout to prevent layout shift after inizialisation of specific elements like accordion
		let timeout = 1500;
		if ($('#ce' + href[1], box).length > 0) {
			scrollToElement($('#ce' + href[1], box), { timeout: timeout });
		} else if ($('#c' + href[1]).length > 0) {
			scrollToElement($('#c' + href[1], box), { timeout: timeout });
		} else {
			return false;
		}
	} else if($(location.hash).length > 0) {
		scrollToElement($(location.hash));
	}

	// Init Wow Book
	if(getCookie('ignoreIframeBreaker') === 'true' && typeof $.fn.wowBook !== 'undefined') {
		initWowBook();
	}
}

function initSearchItemSlider(items) {
	if (items.length === 0) return;

	const elem = items.shift();
	const $this = $(elem);
	const slider = $(elem).find('.swiper-container').get(0);

	let
		grabCursor = true,
		allowTouchMove = true;

	if ($this.hasClass('swiper-slide')) {
		grabCursor = false;
		allowTouchMove = false;
	}

	const config = {
		autoplay: false,
		loop: false,
		rewind: true,
		grabCursor: grabCursor,
		allowTouchMove: allowTouchMove,
		lazyPreloadPrevNext: 2,
		navigation: {
			nextEl: $this.find('.swiper-button-next').first().get(0),
			prevEl: $this.find('.swiper-button-prev').first().get(0),
		},
		pagination: {
			el: $this.find('.swiper-pagination').get(0),
			type: 'fraction',
			renderFraction: function (currentClass, totalClass) {
				return '<div class="d-flex flex-row">' +
					'   <div class="swiper-pagination-current flex-grow-1 text-end ' + currentClass + '"></div>' +
					'   <div class="swiper-pagination-seperator">&nbsp;/&nbsp;</div>' +
					'   <div class="swiper-pagination-total  flex-grow-1 text-start ' + totalClass + '"></div>' +
					'</div>';
			}
		},
		on: {
			init: function (swiper) {
				// lazyload is enabled
				if (typeof window.bLazy?.revalidate === 'function') {
					window.bLazy.revalidate();
				}
			},
			slideChange: function(swiper) {
				// lazyload is enabled
				if (typeof window.bLazy?.revalidate === 'function') {
					window.bLazy.revalidate();
				}
			},
			slideChangeTransitionEnd: function (swiper) {
				// lazyload is enabled
				if (typeof window.bLazy?.revalidate === 'function') {
					window.bLazy.revalidate();
				}
			},
		}
	};

	let searchItemSlider = new Swiper(slider, config);

	setTimeout(() => {
		initSearchItemSlider(items);
	}, 15);
}

// Scroll
//
function scroll(box = document.body) {
	if (window.enviroment === 'dev') {
		console.info('scroll');
	}

	const scrollPosition = $(window).scrollTop();
	const scrollPositionBottom = scrollPosition + $(window).outerHeight();
	let scrollDirection = lastScrollDirection;

	$('body').css('--scroll-position', `${scrollPosition}px`);

	// Directions
	//

	if (scrollPosition > lastScrollPosition) {
		// Scrolling down
		if (lastScrollDirection === 'up') {
			lastScrollDirectionChangePosition = lastScrollPosition;
		}
		if (scrollPosition - lastScrollDirectionChangePosition >= 10) {
			scrollDirection = 'down';
		}
	} else if (scrollPosition < lastScrollPosition) {
		// Scrolling up
		if (lastScrollDirection === 'down') {
			lastScrollDirectionChangePosition = lastScrollPosition;
		}
		scrollDirection = 'up';
	}
	lastScrollDirection = scrollDirection;

	// Viewport
	//

	let previousElement = 'undefined';
	let delay = 5000;
	$('.viewport:not(.is-in-viewport)').each(function () {
		let additionalOffset = 0;
		if (!$(this).hasClass('real-viewport')) {
			additionalOffset = $(window).outerHeight() / 3;
		}
		let itemOffset = $(this).offset().top - additionalOffset;
		let itemOffsetBottom = $(this).offset().top + $(this).outerHeight();
		if (scrollPositionBottom >= itemOffset && scrollPosition < itemOffsetBottom) {
			// @todo: add delay with attr or css class for same childs on same height
			$(this).addClass('is-in-viewport');
			setTimeout(function () {
				if (typeof window.bLazy?.revalidate === 'function') {
					window.bLazy.revalidate();
				}
			}, 500);
		}
	});

	// Pause/Play video
	$('.video.init').each(function () {
		let itemOffset = $(this).offset().top - ($(window).outerHeight() / 3);
		let itemOffsetBottom = $(this).offset().top + $(this).outerHeight();

		if (itemOffset < scrollPositionBottom && itemOffsetBottom > scrollPosition && $(this).hasClass('resume')) {
			Video.play($(this));
			$(this).removeClass('resume');
		} else if ((itemOffset >= scrollPositionBottom || itemOffsetBottom <= scrollPosition) && $(this).hasClass('playing')) {
			Video.pause($(this));
			$(this).addClass('resume');
		}
	});

	// Scroll classes
	//

	// Body
	if (scrollPosition > 0 || ($('body').hasClass('noheader') && scrollPosition > 100 && !$('body').hasClass('scroll'))) {
		$('body').addClass('scroll');
		if (scrollDirection == 'up' && !$('body').hasClass('scroll-to-element')) {
			$('body').addClass('scroll-upwards');
		} else if ($('body').hasClass( 'scroll-upwards')) {
			$('body').removeClass('scroll-upwards');
		}
	} else {
		$('body').removeClass('scroll scroll-upwards');
	}

	// Header
	if (scrollPosition > headerScrollOffset) {
		if($('#header').hasClass('scroll') === false) {
			$('#header').addClass('scroll');
			setTimeout(function() {
				recalcScrollHeight();
			}, 500);
		}
	} else {
		if($('#header').hasClass('scroll') === true) {
			$('#header').removeClass('scroll');
			setTimeout(function() {
				recalcScrollHeight();
			}, 500);
		}
	}

	// Sticky top
	$('div[class*="sticky-top"]').each(function () {
		let offset = $(this).offset().top - parseInt($(this).css('top'));
		if (scrollPosition >= offset && !$(this).hasClass('scroll')) {
			$(this).addClass('scroll');
		} else if (scrollPosition < offset && $(this).hasClass('scroll')) {
			$(this).removeClass('scroll');
		}
	});

	// Set last scroll position
	lastScrollPosition = scrollPosition;
}

// Passive scroll event listener
let scrollTicking = false;
function requestScrollUpdate(box = document.body) {
	if (scrollTicking) {
		return;
	}
	scrollTicking = true;
	window.requestAnimationFrame(function () {
		scroll(box);
		scrollTicking = false;
	});
}

document.addEventListener('scroll', function () {
	if (window.enviroment === 'dev') {
		// console.info('document scroll');
	}

	requestScrollUpdate();
}, passiveSupport() ? { passive: true } : false);

// Passive scroll event listener for scroll containers
let bLazyRevalidateTimeout = null;
document.querySelectorAll('.scrollcontainer').forEach(function (elem) {
	elem.addEventListener('scroll', function () {
		if (window.enviroment === 'dev') {
			// console.info('scrollcontainer scroll');
		}

		window.clearTimeout(bLazyRevalidateTimeout);
		bLazyRevalidateTimeout = window.setTimeout(function () {
			if (typeof window.bLazy?.revalidate === 'function') {
				window.bLazy.revalidate();
			}
		}, 100);
	}, passiveSupport() ? { passive: true } : false);
});


// ScrollToElement
function scrollToElement(elem, { speed = 1000, referenceContainer, timeout = 0, additionalOffset = 50 } = {}) {
	if($(elem).length === 0) {
		return;
	}

	setTimeout(function () {
		let offset = $(elem).offset().top;

		if (!referenceContainer) {
			referenceContainer = $('html, body');
		} else {
			offset = $(elem).position().top + $(referenceContainer).scrollTop();
		}

		offset -= additionalOffset;

		let fixedOffset = window.scrollOffset;

		// Inversible offset for sticky elements in fullscreen container
		let inverseOffset = 0;
		if ($(elem).closest('.fullscreen-container').length > 0 && $(elem).closest('.fullscreen-container').find('> .sticky-top, > .sticky-sm-top, > .sticky-md-top, > .sticky-lg-top, > .sticky-xl-top, > .sticky-xxl-top').length > 0) {
			let stickyTopElements = $(elem).closest('.fullscreen-container').find('> .sticky-top, > .sticky-sm-top, > .sticky-md-top, > .sticky-lg-top, > .sticky-xl-top, > .sticky-xxl-top');
			$(stickyTopElements).each(function() {
				if ($(this).css('position') === 'sticky') {
					inverseOffset += $(this).outerHeight();
				}
			});
			offset -= inverseOffset;
		}

		if ($('body').hasClass('scroll-animation') || offset < headerScrollOffset) {
			offset -= fixedOffset;
		}

		$(referenceContainer).stop(true, true).animate({scrollTop: offset}, {duration: speed, start: function() {
				$(referenceContainer).addClass('scroll-to-element');
			},
			complete: function() {
				setTimeout(function() {
					$(referenceContainer).removeClass('scroll-to-element');
				}, 300);
			}
		});
	}, timeout);
}

// Recalc scroll height
function recalcScrollHeight() {
	window.scrollOffset = 0;
	$('[data-formwidget="offset"]').each(function() {
		window.scrollOffset += $(this).outerHeight();
	});
}

// Recalc sticky top height
function recalcStickyTopHeight() {
	const stickySelector = '.sticky-top, .sticky-sm-top, .sticky-md-top, .sticky-lg-top, .sticky-xl-top, .sticky-xxl-top';
	const containerSelector = '.article, .fullscreen, .fullscreen-container';

	const containerHeights = new Map();

	$(stickySelector).each(function () {
		const $sticky = $(this);
		const $container = $sticky.closest(containerSelector);

		if (!$container.length) {
			return;
		}

		const container = $container.get(0);
		const height = $sticky.outerHeight();
		const currentHeight = containerHeights.get(container) || 0;

		containerHeights.set(container, currentHeight + height);
	});

	containerHeights.forEach(function (height, container) {
		$(container).css('--sticky-top-height', height + 'px');
	});
}

// Recalc dropdown menu min height
function recalcDropdownMenuMinHeight(elem, firstLayer, timeout = 0) {
	if (typeof elem === 'undefined' || typeof firstLayer === 'undefined') {
		return;
	}

	setTimeout(function () {
		// Calc subnavigation min height
		let minHeight = 0;
		$(firstLayer).find('.outer-container').each(function () {
			let itemHeight = $(this).outerHeight();
			if (itemHeight > minHeight) {
				minHeight = itemHeight;
			}
		});

		if (typeof minHeight !== 'undefined' && minHeight !== 0) {
			$(elem).css('--min-height', `${minHeight}px`);
		}
	}, timeout);
}

function calcArticleSearchOffset(box) {
	$('.articlesearch:not(.map-view)', box).each(function () {
		let elem = $(this);
		if ($(elem).closest('.fullscreen-container').length > 0) {
			elem = $(elem).closest('.fullscreen-container');
		}

		let offsetTop = $(elem).offset().top;
		$(elem).css('--article-offset-top', `${offsetTop}px`);
	})
}

function initArticleSearchHeightObserver(box) {
	$('.articlesearch:not(.map-view)', box).each(function () {
		const elem = this;
		if (elem.dataset.heightObserverInit) return;

		const resizeObserver = new ResizeObserver(entries => {
			for (let entry of entries) {
				const height = entry.contentRect.height;
				elem.style.setProperty('--article-height', `${height}px`);
			}
		});

		resizeObserver.observe(elem);
		elem.dataset.heightObserverInit = 'true';
	});
}

// Resize
//

function resize(widthResize = false, heightResize = false, box = document) {
	const $window = $(window);
	const $box = $(box);

	const hasFullResize = widthResize && heightResize;

	if (window.enviroment === 'dev') {
		console.info('resize');
	}

	windowWidth = $window.innerWidth();
	windowHeight = $window.innerHeight();

	if (hasFullResize) {
		getScrollHeight();
		getStickyTopHeight();

		window.breakpoint = detectBreakpoint();

		// @todo: close navigation
	}

	if (widthResize) {
		CssCalc.refresh();
	}

	recalcResizeLayout($box);
}

function recalcResizeLayout($box) {
	recalcScrollHeight();
	recalcStickyTopHeight();

	recalcHeaderMinHeight();
	recalcHeaderBottomHeight();

	calcArticleSearchOffset();

	initArticleSearchHeightObserver();

	$('.mainnav.dropdown-nav', $box).each(function () {
		const elem = $(this);
		const firstLayer = elem.find('nav > ul > li');

		recalcDropdownMenuMinHeight(elem, firstLayer);
	});
}


// Ready
//
$(document).ready(function(){
	if (window.enviroment === 'dev') {
		console.info('ready');
	}

	load();
});


// Mouseup
//
$(document).mouseup(function(e) {
	handleNavOutsideClick(e);
	handleSearchOutsideClick(e);
});

function handleNavOutsideClick(e) {
	let container = $(".headertop, .fullscreenmenu, #headerbottom, .mainnav");
	if (!container.is(e.target) && container.has(e.target).length === 0) {
		if($('body').hasClass('menuopen') === true) {
			closeMenu();
			closeAllOpenFullscreenMenus();
			closeAllMainNavItems();
		}
	}
}

function handleSearchOutsideClick(e) {
	let container = $(".search-form");
	if (!container.is(e.target) && container.has(e.target).length === 0) {
		if($(container).hasClass('visible') === true) {
			$(container).removeClass('visible');
		}
	}
}

// Fullscreen menu
//

window.fullscreenMenuTempZIndex = 1049;
window.fullscreenMenuCloseDelay = 500;
window.fullscreenMenuCloseTimer = null;
window.openMenuTimer = null;
window.closeMenuTimer = null;

function openFullscreenMenuWithPriority(el, toggle) {
	const currentEl = $(el);

	if (window.fullscreenMenuCloseTimer) {
		window.clearTimeout(window.fullscreenMenuCloseTimer);
		window.fullscreenMenuCloseTimer = null;
	}

	$('.fullscreenmenu').css('z-index', '');
	currentEl.css('z-index', window.fullscreenMenuTempZIndex);

	openFullscreenMenu(currentEl, toggle);
	openMenu(0);

	window.fullscreenMenuCloseTimer = window.setTimeout(function () {
		$('.fullscreenmenu.is-open').not(currentEl).each(function () {
			const otherEl = $(this);
			const otherId = otherEl.attr('id');
			const otherToggle = $('.fullscreenmenu-toggle[data-toggle="#' + otherId + '"]');

			closeFullscreenMenu(otherEl, otherToggle);
		});

		window.setTimeout(function () {
			currentEl.css('z-index', '');
			window.fullscreenMenuCloseTimer = null;
		}, window.fullscreenMenuCloseDelay)
	}, window.fullscreenMenuCloseDelay);
}

// Resize event listener
//

let resizeEndTimer = null;

let lastKnownWindowWidth = window.innerWidth;
let lastKnownWindowHeight = window.innerHeight;

$(window).on('resize', function () {
	clearTimeout(resizeEndTimer);

	resizeEndTimer = setTimeout(function () {
		const currentWindowWidth = window.innerWidth;
		const currentWindowHeight = window.innerHeight;

		const widthResize = lastKnownWindowWidth !== currentWindowWidth;
		const heightResize = lastKnownWindowHeight !== currentWindowHeight;

		if (!widthResize && !heightResize) {
			return;
		}

		lastKnownWindowWidth = currentWindowWidth;
		lastKnownWindowHeight = currentWindowHeight;

		windowWidth = currentWindowWidth;
		windowHeight = currentWindowHeight;

		if (window.enviroment === 'dev') {
			console.info('window resize');
		}

		resize(widthResize, heightResize);
	}, 150);
});


// Functions library
//

// Detect enviroment
function detectEnviroment() {
	const hostname = window.location.hostname || '';

	if (/^(localhost|dev|ddev)(\.|$)|\.ddev\./.test(hostname)) {
		return 'dev';
	}
	return 'live';
}

// Get scrollheight
function getScrollHeight() {
	recalcScrollHeight();
}

// Get sticky top height
function getStickyTopHeight() {
	recalcStickyTopHeight();
}
/* END get scroll height with offset */

// Detect breakpoint
function detectBreakpoint() {
	let breakpoint;
	const prevBreakpoint = window.breakpoint;

	/* check if bootstrap display class is not none */
	if($('body > span.d-xxl-block').css('display') != 'none') {
		breakpoint = 'xxl';
	} else if($('body > span.d-xl-block').css('display') != 'none') {
		breakpoint = 'xl';
	} else if($('body > span.d-lg-block').css('display') != 'none') {
		breakpoint = 'lg';
	} else if($('body > span.d-md-block').css('display') != 'none') {
		breakpoint = 'md';
	} else if($('body > span.d-sm-block').css('display') != 'none') {
		breakpoint = 'sm';
	} else if($('body > span.d-block').css('display') != 'none') {
		breakpoint = 'xs';
	}

	/* add breakpoint class to body */
	if (!$('body').hasClass(breakpoint)) {
		$('body').removeClass('xxl xl lg md sm xs').addClass(breakpoint);
	}

	if (prevBreakpoint !== breakpoint) {
		$(window).trigger('breakpoint:change', [breakpoint, prevBreakpoint]);
	}

	return breakpoint;
}

function bpIndex(bp) {
	const i = window.breakpoints.indexOf(bp);
	return i === -1 ? 0 : i;
}

// Breakpoint change event listener
$(window).on('breakpoint:change', function (e, bp, prev) {
	if (window.enviroment === 'dev') {
		console.info('breakpoint:change');
	}

	// Gallery
	const gallery = $('.articlegallery');
	if (gallery && gallery.length) {
		$(gallery).each(function () {
			if (typeof getGalleryMode === 'undefined') {
				return;
			}

			const elem = $(this);
			const mode = getGalleryMode(elem, bp);

			if (mode == 'slider') {
				initSliderGallery(elem);
			}

			if (typeof prev !== 'undefined') {
				const prevMode = getGalleryMode(elem, prev);
				if (mode != 'slider' && mode != prevMode) {
					if (typeof destroySliderGallery === 'undefined') {
						return;
					}

					destroySliderGallery(elem);
				}
			}
		});
	}

	// Text collapse
	const collapseText = $('[class*="text-collapse-"], [class*="text-xs-collapse-"], [class*="text-sm-collapse-"], [class*="text-md-collapse-"], [class*="text-lg-collapse-"], [class*="text-xl-collapse-"], [class*="text-xxl-collapse-"]');
	if (collapseText && collapseText.length && typeof textCollapse === 'function') {
		textCollapse(collapseText);
	}

	// Slide switch
	gridSlideSwitch();
});

// Repeat elements
const Repeatable = function() {
	this.init = function(box) {
		let outerThis = this;
		$('.repeatablewrapper', box).each(function() {
			let containerElement = $(this).find('.repeatablecontainer');
			let draftElement = $(this).find('.repeatabledraft');
			$(this).find('.removerepeatable').click(function() {
				outerThis.remove(containerElement, draftElement);
			});
			$(this).find('.addrepeatable').click(function() {
				outerThis.add(containerElement, draftElement);
			}).click();
		});
	};

	this.add = function(containerElement, draftElement) {
		let copiedElement = draftElement.html();
		containerElement.append(copiedElement);

		this.onChange(containerElement);
	};

	this.remove = function(containerElement, draftElement) {
		containerElement.find('.repeatableitem').last().remove();

		this.onChange(containerElement);
	};

	this.onChange = function(containerElement) {
		containerElement.find('.repeatableitem').each(function(k, v) {
			let oldIndex = $(this).attr('data-repeatable-index');
			$(this).attr('data-repeatable-index', k);

			$(this).find('input, select, [data-for], .num').each(function() {
				if($(this).attr('name') && $(this).attr('name').indexOf('['+oldIndex+']') !== -1) {
					let newName = $(this).attr('name').replace('['+oldIndex+']', '['+k+']');
					$(this).attr('name', newName);
					if($(this).closest('.childage').length === 0) {
						$(this).removeAttr('disabled');
					}
				} else if($(this).attr('data-for') && $(this).attr('data-for').indexOf('['+oldIndex+']') !== -1) {
					let newName = $(this).attr('data-for').replace('['+oldIndex+']', '['+k+']');
					$(this).attr('data-for', newName);
				} else if($(this).hasClass('num')) {
					$(this).html(k + 1);
				}
			});
		});

		let maxItems = containerElement.attr('data-repeatable-max');
		if(containerElement.find('.repeatableitem').length >= maxItems) {
			containerElement.closest('.repeatablewrapper').find('.addrepeatable').hide();
		} else {
			containerElement.closest('.repeatablewrapper').find('.addrepeatable').show();
		}

		if(containerElement.find('.repeatableitem').length <= 1) {
			containerElement.closest('.repeatablewrapper').find('.removerepeatable').hide();
		} else {
			containerElement.closest('.repeatablewrapper').find('.removerepeatable').show();
		}
	};
};

// Slider
//

window.Slider = function (elem, config = {}, events = {}) {
	// set elem
	this.elem = elem;

	// find swiper-container for initialation
	this.sliderContainer = $(this.elem);
	if (!$(this.sliderContainer).hasClass('swiper-container')) {
		this.sliderContainer = $(this.sliderContainer).find('.swiper-container');
		if ($(this.sliderContainer).length <= 0) {
			if ($(this.sliderContainer).find('div[class*="-container"]').length > 0 && $(this.sliderContainer).find('div[class*="-container"] > div[class*="-wrapper"]').length > 0 && $(this.sliderContainer).find('div[class*="-container"] > div[class*="-wrapper"] > div[class*="-items"]').length > 0) {
				$(this.elem).addClass('js-manipulated-swiper');
				this.sliderContainer = $(this.sliderContainer).find('div[class*="-container"]').addClass('swiper-container');
				$(this.sliderContainer).find('div[class*="-container"] > div[class*="-wrapper"]').addClass('swiper-wrapper');
				$(this.sliderContainer).find('div[class*="-container"] > div[class*="-wrapper"] > div[class*="-items"]').addClass('swiper-slide');
				console.info('better usage is as server side rendered slider:', this.elem);
			} else {
				console.info('no swiper container found for element:', this.elem);
				return false;
			}
		}
	}

	this.sliderWrapper = $(this.sliderContainer).find('.swiper-wrapper').first();

	// preset & set if slider data exist
	this.slider;
	if (typeof $(this.elem).data('slider') !== 'undefined') {
		this.slider = $(this.elem).data('slider');
	}

	// preset & set if slider item data exist
	this.countItems = 0;
	if (typeof $(this.sliderContainer).data('items') !== 'undefined') {
		this.countItems = $(this.sliderContainer).data('items');
	}

	// Get config as data attribute
	try {
		this.dataConfig = $(this.sliderContainer).data('config')
			? JSON.parse(
				$(this.sliderContainer).data('config')
					.replace(/'/g, '"')
					.replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":')
			)
			: {};
	} catch (error) {
		this.dataConfig = {};
		console.error('Ungültiges data-config Format:', $(this.sliderContainer).data('config'), error);
	}

	this.config = {
		default: {
			effect: 'slide', // 'slide' | 'fade' | 'cube' | 'coverflow' | 'flip'
			loop: false,
			rewind: false,
			keyboard: false,
			spaceBetween: 0,
			slidesPerView: 1,
			//maxSlidesPerView: 1,
			speed: 1000,
			autoplay: false,
			centeredSlides: false,
			allowTouchMove: true,
			parallax: false,
			touchEventsTarget: 'container',
			// Disable original resize observer/window resize
			resizeObserver: false,
			updateOnWindowResize: false,
			filterHiddenSlides: false,
			a11y: {
				prevSlideMessage: strings.swiperPrevSlide[lang],
				nextSlideMessage: strings.swiperNextSlide[lang],
				firstSlideMessage: strings.swiperFirstSlide[lang],
				lastSlideMessage: strings.swiperLastSlide[lang],
				paginationBulletMessage: strings.swiperPaginationBullet[lang],
				slideLabelMessage: strings.swiperSlideLabel[lang],
				containerMessage: strings.swiperContainerMessage[lang],
				containerRoleDescriptionMessage: strings.swiperContainerRoleDescription[lang],
				itemRoleDescriptionMessage: strings.swiperItemRoleDescription[lang],
			},
		},
		passed: config,
		data: this.dataConfig,
	};

	this.controls = {
		default: {
			navigation: {
				nextEl: $(this.elem).find('.swiper-button-next').get(0),
				prevEl: $(this.elem).find('.swiper-button-prev').get(0),
			},
			pagination: {
				el: $(this.elem).find('.swiper-pagination').get(0),
				type: 'bullets',
				/*
				type: 'fraction',
				formatFractionCurrent: function (number) {
					return prependZero(number);
				},
				formatFractionTotal: function (number) {
					return prependZero(number);
				},
				renderFraction: function (currentClass, totalClass) {
					return '<div class="' + currentClass + '"></div>' +
						'<div class="' + totalClass + '"></div>';
				}
				*/
			},
		}
	}

	this.events = {
		default: {
			init: function (swiper) {
				// lazyload is enabled
				if (typeof window.bLazy?.revalidate === 'function') {
					window.bLazy.revalidate();
				}

				// check first slide
				let firstSlide = swiper.slides[0];

				// check next slide for video slide
				let restartAutoplay = false;
				if (typeof swiper.params.autoplay.enabled !== 'undefined' && swiper.params.autoplay.enabled !== false) {
					restartAutoplay = true;
				}
				if (swiper.slides[1]) {
					let nextSlide = swiper.slides[1];
					if ($(nextSlide).hasClass('video-slide')) {
						restartAutoplay = false;
					}
				}

				// check if first slide is video slide
				if ($(firstSlide).hasClass('video-slide')) {
					let video = $(firstSlide).find('.video');
					if ($(video).length > 0) {
						let videoSettings = {
							callback: {
								play: function () {
									swiper.autoplay.stop();
								},
								ended: function () {
									swiper.slideNext();
									if (restartAutoplay) {
										swiper.autoplay.start();
									}
									Video.stop(video);
								}
							}
						};
						if ($(video).attr('autoplay') && $(video).attr('autoplay') !== 'false') {
							swiper.autoplay.stop();
							Video.play(video, videoSettings);
						} else if (!$(video).hasClass('init')) {
							Video.init(video, videoSettings);
						}
					}
				}

				if (typeof swiper.params.slidesPerView !== 'undefined' && swiper.params.slidesPerView > 1) {
					if (typeof swiper.slides !== 'undefined' && swiper.slides.length > 0) {
						for (let i = 0; i < swiper.slides.length; i++) {
							let slide = swiper.slides[i];
							if ($(slide).length > 0 && $(slide).hasClass('video-slide')) {
								let video = $(slide).find('.video');

								let videoSettings = {
									callback: {
										play: function () {
											swiper.autoplay.stop();
										},
										ended: function () {
											swiper.slideNext();
											if (restartAutoplay) {
												swiper.autoplay.start();
											}
											Video.stop(video);
										}
									}
								};
								if (!$(video).hasClass('init')) {
									Video.init(video, videoSettings);
								}
							}
						}
					}
				}
			},
			slideChange: function(swiper) {
				// lazyload is enabled
				if (typeof window.bLazy?.revalidate === 'function') {
					window.bLazy.revalidate();
				}

				// get active & prev slide
				let activeIndex = swiper.activeIndex;
				let previousIndex = swiper.previousIndex;
				let activeSlide = swiper.slides[activeIndex];
				let previousSlide = swiper.slides[previousIndex];

				// check next slide for video slide
				let restartAutoplay = false;
				if (typeof swiper.params.autoplay.enabled !== 'undefined' && swiper.params.autoplay.enabled !== false) {
					restartAutoplay = true;
				}
				if (swiper.slides[activeIndex + 1]) {
					let nextSlide = swiper.slides[activeIndex + 1];
					if ($(nextSlide).hasClass('video-slide')) {
						restartAutoplay = false;
					}
				}

				// check if active slide is video slide
				if ($(activeSlide).hasClass('video-slide')) {
					let video = $(activeSlide).find('.video').get(0);
					if ($(video).length > 0) {
						let videoSettings = {
							callback: {
								play: function () {
									swiper.autoplay.stop();
								},
								ended: function () {
									swiper.slideNext();
									if (restartAutoplay) {
										swiper.autoplay.start();
									}
									Video.stop(video);
								}
							}
						};

						if ($(video).attr('autoplay') && $(video).attr('autoplay') !== 'false') {
							swiper.autoplay.stop();
							Video.play(video, videoSettings);
						} else if (!$(video).hasClass('init')) {
							Video.init(video, videoSettings);
						}
					}
				}

				// check if previous slide is video slide
				if ($(previousSlide).hasClass('video-slide')) {
					let video = $(previousSlide).find('.video').get(0);
					if ($(video).attr('autoplay') && $(video).attr('autoplay') !== 'false') {
						swiper.autoplay.stop();
					}
					Video.pause(video);
				}
			},
			slideChangeTransitionEnd: function (swiper) {
				// lazyload is enabled
				if (typeof window.bLazy?.revalidate === 'function') {
					window.bLazy.revalidate();
				}
			},
		},
		passed: events,
		data: (typeof $(this.sliderContainer).data('events') !== 'undefined') ? $(this.sliderContainer).data('events') : {},
	};

	$(this.elem).data('events', this.events.passed);

	this.parameter = {};

	this.init = function(config, events) {
		// merged config to parameter
		this.parameter = this.mergeConfig();

		// add events to parameter
		this.parameter['on'] = this.mergeEvents(events);

		// check if default controls are necessary
		// check and set navigation
		if (typeof this.parameter.navigation === 'undefined' && typeof this.controls.default.navigation !== 'undefined' && $(this.sliderContainer).find($(this.controls.default.navigation.prevEl)).length > 0 && $(this.sliderContainer).find($(this.controls.default.navigation.nextEl)).length > 0) {
			this.parameter['navigation'] = this.controls.default.navigation;
		}

		// check and set navigation
		if (typeof this.parameter.pagination === 'undefined' && typeof this.controls.default.pagination !== 'undefined' && $(this.sliderContainer).find($(this.controls.default.pagination.el)).length > 0) {
			this.parameter['pagination'] = this.controls.default.pagination;
		}

		// init swiper
		if (typeof Swiper !== 'undefined') {
			// Before initialization: ensure original indexing and filter out hidden slides for current breakpoint
			if (this.parameter.filterHiddenSlides) {
				this.restoreAllSlides();
				this.removeHiddenSlides();
			}

			// count items/slides and modifiy default behaviour
			this.countItems = $(this.elem).find('.swiper-slide').length;
			$(this.sliderContainer).attr({'data-items': this.countItems});

			// Support maxSlidesPerView: cap slidesPerView to the number of slides
			// Usage: pass { maxSlidesPerView: N } at root or inside breakpoints; when present and
			// slidesPerView is not explicitly set, it will be computed as min(N, countItems).
			// If slidesPerView is set, it will be capped to maxSlidesPerView and countItems.
			if (typeof this.parameter === 'object' && this.parameter) {
				// Base params
				if (typeof this.parameter.maxSlidesPerView !== 'undefined') {
					let maxBase = Number(this.parameter.maxSlidesPerView);
					if (!isNaN(maxBase) && maxBase > 0) {
						let baseSpv =  maxBase;
						// Ensure numeric
						baseSpv = Number(baseSpv);
						if (!Number.isFinite(baseSpv) || baseSpv <= 0) {
							baseSpv = 1;
						} else {
							baseSpv = Math.round(baseSpv * 100) / 100;
						}
						this.parameter.slidesPerView = Math.min(maxBase, this.countItems, baseSpv);
					}
				}
				// Breakpoints params
				if (typeof this.parameter.breakpoints === 'object' && this.parameter.breakpoints) {
					Object.keys(this.parameter.breakpoints).forEach((bp) => {
						let cfg = this.parameter.breakpoints[bp];
						if (cfg && typeof cfg.maxSlidesPerView !== 'undefined') {
							let maxBp = Number(cfg.maxSlidesPerView, 10);
							if (!isNaN(maxBp) && maxBp > 0) {
								let bpSpv = maxBp;
								bpSpv = Number(bpSpv, 10);
								if (!Number.isFinite(bpSpv) || bpSpv <= 0) {
									bpSpv = 1;
								} else {
									bpSpv = Math.round(bpSpv * 100) / 100;
								}
								cfg.slidesPerView = Math.min(maxBp, this.countItems, bpSpv);
							}
						}
					});
				}
			}

			// check for videos
			this.videosInSlider = $(this.sliderContainer).find('.swiper-slide.video-slide');

			// check for videos
			this.youTubeVideoInSlider = $(this.sliderContainer).find('.swiper-slide.video-slide .youtube-video-container').length;

			// video consent required (actually build only with gnconsent)
			if (consentToolActive) {
				let youTubeConsent = true;
				if (consentTool === 'gnConsent' && gnConsent.getConsent('youTube') !== null && gnConsent.getConsent('youTube') === false) {
					youTubeConsent = false;
				}
				let vimeoConsent = true;
				if (consentTool === 'gnConsent' && gnConsent.getConsent('vimeo') !== null && gnConsent.getConsent('vimeo') === false) {
					vimeoConsent = false;
				}

				// control each video slide
				let sliderContainer = this.sliderContainer;
				$(this.videosInSlider).each(function () {
					let videoSlide = $(this);
					if ($(videoSlide).find('.youtube-video-container').length > 0 && youTubeConsent === false || $(videoSlide).find('.vimeo-video-container').length > 0 && vimeoConsent === false) {
						// append video slide with no consent to the end
						$(videoSlide).appendTo($(sliderContainer).find('.swiper-wrapper'));
					}
				});
			}

			if (this.countItems <= 1) {
				this.parameter['loop'] = false;
				//this.parameter['navigation'] = false;
				//this.parameter['pagination'] = false;
				this.parameter['allowTouchMove'] = false;
			}

			// setting according to documentation (https://swiperjs.com/swiper-api#param-loop)
			if (typeof this.parameter['slidesPerView'] !== 'undefined' && this.parameter['slidesPerView'] > 1 && this.countItems < (this.parameter['slidesPerView'] * 2)) {
				this.parameter['loop'] = false;
			}

			// if youtube slide exist & loop is active bugfix with rewind
			if (this.youTubeVideoInSlider > 0 && (typeof this.parameter['loop'] !== 'undefined' && this.parameter['loop']) && (typeof this.parameter['rewind'] !== 'undefined' && !this.parameter['rewind'])) {
				this.parameter['loop'] = 0;
				this.parameter['rewind'] = true;
			}

			this.slider = new Swiper($(this.sliderContainer).get(0), this.parameter);

			// set to storage (needed for destroy an manipulation after initialisation)
			$(this.elem).data('slider', this.slider);

			// Nutze IntersectionObserver für Sichtbarkeit und ResizeObserver für Größenänderungen
			// todo: comment remove, accommodation detail page to check for PAT
			this.setupPerformanceObservers();
		} else {
			console.warn('swiper.js is not included');
			return false;
		}
	}

	this.destroy = function() {
		if (typeof Swiper !== 'undefined') {

			// Disconnect observers
			if (this.resizeObserver) this.resizeObserver.disconnect();
			if (this.intersectionObserver) this.intersectionObserver.disconnect();

			// Clear timers
			if (this.resizeDebounceTimer) clearTimeout(this.resizeDebounceTimer);
			if (this.rafId) cancelAnimationFrame(this.rafId);

 			// unbind breakpoint handler
			/*
			if (this.bpHandlerBound) {
				$(window).off('breakpoint:change', this.onBreakpointChange);
				this.bpHandlerBound = false;
			}
			*/

			this.slider.destroy();

			if ($(this.elem).hasClass('js-manipulated-swiper')) {
				$(this.elem).removeClass('js-manipulated-swiper');
				$(this.sliderContainer).removeClass('swiper-container');
				$(this.sliderContainer).find('.swiper-wrapper').removeClass('.swiper-wrapper');
				$(this.sliderContainer).find('.swiper-slide').removeClass('.swiper-slide');
			}
		}
	}
	this.mergeConfig = function(config = {}) {
		return {
			...this.config.default,
			...this.config.data,
			...this.config.passed,
			...config,
		};
	}
	this.mergeEvents = function(events = {}) {
		return {
			...this.events.default,
			...this.events.data,
			...this.events.passed,
			...events,
		};
	}

	// Detach/attach slides depending on visibility
	// storage for breakpoint-based hidden slides handling
	// Keep original order and track temporarily removed slides
	this.origIndexed = false; // whether original indices are set
	this.removedSlides = []; // array of { index: Number, $el: jQuery }
	//this.bpHandlerBound = false; // whether the breakpoint handler is bound

	// Mark original indices once
	this.ensureOrigIndex = () => {
		if (this.origIndexed) return;
		const slides = this.sliderWrapper.children('.swiper-slide');
		if (slides.length === 0) return;

		slides.each(function(i){
			if ($(this).hasClass('swiper-slide-duplicate')) return;
			$(this).attr('data-orig-index', i);
		});
		this.origIndexed = true;
	};

	// Check visibility
	this.isSlideVisible = (slideEl) => {
		const el = $(slideEl);
		// Always ignore swiper duplicates
		if (el.hasClass('swiper-slide-duplicate')) return true;
		return el.css('display') !== 'none';
	};

	// Restore all previously removed slides to their original positions
	this.restoreAllSlides = () => {
		if (!this.removedSlides || this.removedSlides.length === 0) return;
		// sort by original index to insert in order
		this.removedSlides.sort((a,b) => a.index - b.index).forEach(item => {
			const idx = item.index;
			const siblings = this.sliderWrapper.children('.swiper-slide').not('.swiper-slide-duplicate');
			if (siblings.length === 0 || idx >= siblings.length) {
				this.sliderWrapper.append(item.$el);
			} else {
				// insert before element currently at idx
				siblings.eq(idx).before(item.$el);
			}
		});
		this.removedSlides = [];
	};

	// Detach hidden slides based on visibility
	this.removeHiddenSlides = () => {
		this.ensureOrigIndex();
		const self = this;
		const slidesToDetach = [];

		this.sliderWrapper.children('.swiper-slide').not('.swiper-slide-duplicate').each(function(){
			const slide = $(this);
			const visible = self.isSlideVisible(slide);
			if (!visible) {
				const origIndexAttr = slide.attr('data-orig-index');
				const origIndex = typeof origIndexAttr !== 'undefined' ? parseInt(origIndexAttr, 10) : slide.index();
				slidesToDetach.push({ index: origIndex, $el: slide });
			}
		});

		if (slidesToDetach.length > 0) {
			slidesToDetach.forEach(item => {
				self.removedSlides.push({ index: item.index, $el: item.$el.detach() });
			});
		}
	};

	// Breakpoint change handler (restore, re-filter, then update swiper)
	/*
	this.onBreakpointChange = (e, breakpoint, prevBreakpoint) => {
		this.restoreAllSlides();
		this.removeHiddenSlides();

		if (this.slider && typeof this.slider.update === 'function') {
			// If loop is enabled, rebuild looped slides to reflect DOM changes
			try {
				if (this.slider.params && this.slider.params.loop && typeof this.slider.loopDestroy === 'function' && typeof this.slider.loopCreate === 'function') {
					this.slider.loopDestroy();
					this.slider.loopCreate();
				}
				this.slider.update();
				this.slider.slideTo(0);
				if (
					this.slider.params?.autoplay &&
					this.slider.params.autoplay !== false &&
					this.slider.params.autoplay.enabled !== false &&
					this.slider.autoplay &&
					typeof this.slider.autoplay.start === 'function'
				) {
					this.slider.autoplay.start();
				}
			} catch (err) {
				console.warn('Swiper update after breakpoint change failed', err);
			}
		}
	};

	this.bindBreakpointHandler = () => {
		if (this.bpHandlerBound) return;
		$(window).on('breakpoint:change', this.onBreakpointChange);
		this.bpHandlerBound = true;
	};
	*/

	// @todo: optimize
	this.setupPerformanceObservers = () => {
		this.isVisible = false;
		this.lastWidth = this.sliderContainer.width();

		// IntersectionObserver: update only wen visible
		this.intersectionObserver = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				this.isVisible = entry.isIntersecting;
				if (this.isVisible && this.needsUpdate) {
					this.updateSlider();
					this.needsUpdate = false;
				}
			});
		}, {
			rootMargin: '100% 0px',
			threshold: 0.01
		});

		this.intersectionObserver.observe(this.sliderContainer.get(0));

		// ResizeObserver: Only for width changes
		this.resizeObserver = new ResizeObserver((entries) => {
			for (let entry of entries) {
				let newWidth;
				if (entry.contentBoxSize) {
					// Fallback for different browser implementations
					const contentBoxSize = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize;
					newWidth = contentBoxSize.inlineSize;
				} else {
					newWidth = entry.contentRect.width;
				}

				if (Math.abs(newWidth - this.lastWidth) > 1) { // 1px threshold
					this.lastWidth = newWidth;

					// Delete debounce timer
					if (this.resizeDebounceTimer) clearTimeout(this.resizeDebounceTimer);

					// Set debounce timer
					this.resizeDebounceTimer = setTimeout(() => {
						if (this.isVisible) {
							if (this.rafId) cancelAnimationFrame(this.rafId);
							this.rafId = requestAnimationFrame(() => this.updateSlider());
						} else {
							this.needsUpdate = true;
						}
						this.resizeDebounceTimer = null;
					}, 150); // Wait 150ms
				}
			}
		});

		this.resizeObserver.observe(this.sliderContainer.get(0));
	};

	this.updateSlider = () => {
		if (!this.slider || typeof this.slider.update !== 'function') return;

		// Breakpoint-Logik ausführen if neccessary
		if (this.parameter.filterHiddenSlides) {
			this.restoreAllSlides();
			this.removeHiddenSlides();
		}

		try {
			if (this.slider.params && this.slider.params.loop && typeof this.slider.loopDestroy === 'function') {
				this.slider.loopDestroy();
				this.slider.loopCreate();
			}
			this.slider.update();
		} catch (err) {
			console.warn('Slider update failed', err);
		}
	};

	// init slider
	if ($(this.sliderContainer).length > 0 && !$(this.sliderContainer).hasClass('swiper-initialized')) {
		this.init(this.config.passed, this.events.passed);
	}
}

// Slider gallery
function getGalleryMode($g, currentBp) {
	let mode = null;

	if ($g.hasClass('slider-gallery')) mode = 'slider';
	if ($g.hasClass('grid-gallery')) mode = 'grid';

	const max = bpIndex(currentBp);
	for (let i = 1; i <= max; i++) {
		const bp = breakpoints[i];
		if ($g.hasClass('slider-gallery-' + bp)) mode = 'slider';
		if ($g.hasClass('grid-gallery-' + bp)) mode = 'grid';
	}
	return mode; // 'slider' | 'grid' | null
}

window.sliderGallery = [];
const initSliderGallery = function (elem, box) {
	let thumbs = false;
	if ($(elem).find('.thumb')) {
		const thumb = $(elem).find('.thumb');

		const config = {
			autoplay: false,
			slidesPerView: 'auto',
			spaceBetween: 10,
			slidesPerGroup: 1,
		}

		let sliderGalleryThumbEl = new Slider(thumb, config);

		if (!sliderGallery.includes(sliderGalleryThumbEl)) {
			sliderGallery.push(sliderGalleryThumbEl);
		}

		thumbs = {
			swiper: sliderGalleryThumbEl.slider,
		}
	}

	let gallery = elem;
	if ($(elem).find('.gallery').length > 0) {
		gallery = $(elem).find('.gallery');
	}

	const config = {
		autoplay: false,
		loop: false,
		//rewind: true,
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 20,
		grabCursor: true,
		lazyPreloadPrevNext: 2,
		thumbs: thumbs,
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		breakpoints: {
			1441: {
				slidesPerView: 2,
				spaceBetween: 60,
			},
			1281: {
				slidesPerView: 2,
				spaceBetween: 40,
			},
			1081: {
				slidesPerView: 2,
				spaceBetween: 40,
			},
			962: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
			641: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
			421: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
		},
		scrollbar: {
			el: $(elem).find('.swiper-scrollbar').get(0),
			draggable: true,
			enabled: true,
		},
		navigation: {
			nextEl: $(elem).find('.swiper-button-next').first().get(0),
			prevEl: $(elem).find('.swiper-button-prev').first().get(0),
		},
		pagination: {
			el: $(elem).find('.swiper-pagination').get(0),
			type: 'fraction',
			renderFraction: function (currentClass, totalClass) {
				return '<div class="d-flex flex-row">' +
					'	<div class="swiper-pagination-current flex-grow-1 text-end ' + currentClass + '"></div>' +
					'	<div class="swiper-pagination-seperator">&nbsp;/&nbsp;</div>' +
					'	<div class="swiper-pagination-total  flex-grow-1 text-start ' + totalClass + '"></div>' +
					'</div>';
			}
		},
	};

	const events = {};

	if ($(elem).hasClass('single-slider')) {
		config.slidesPerView = 1;

		Object.values(config.breakpoints).forEach(breakpoint => {
			breakpoint.slidesPerView = 1;
		});

		const updateSwiperWidth = function() {
			const $grid = $(gallery).find('[class*="grid"]:has(> .swiper-container)');
			const $swiper = $grid.find('> .swiper-container');
			const $slide = $swiper.find('.swiper-slide').first();
			const $img = $slide.find('img');

			if ($grid.length > 0 && $img.length > 0) {
				let ratio;
				const aspectVar = getComputedStyle($grid.get(0)).getPropertyValue('--aspect-ratio').trim();

				if (aspectVar && aspectVar !== '') {
					if (aspectVar.includes('/')) {
						const parts = aspectVar.split('/');
						ratio = parseFloat(parts[0]) / parseFloat(parts[1]);
					} else {
						ratio = parseFloat(aspectVar);
					}
				}

				if (!ratio || isNaN(ratio)) {
					const ratioStr = $img.attr('data-ratio') || $img.attr('width') + 'x' + $img.attr('height');
					if (ratioStr) {
						const parts = ratioStr.split('x');
						ratio = parseFloat(parts[0]) / parseFloat(parts[1]);
					}
				}

				if (ratio && !isNaN(ratio)) {
					let containerWidth = $grid.width();
					let containerHeight = $grid.height();

					// Subtract prev/next button widths from containerWidth if they are in the same row as the slider
					const $prev = $grid.find('.swiper-button-prev');
					const $next = $grid.find('.swiper-button-next');
					let buttonsWidth = 0;

					const gridStyles = getComputedStyle($grid.get(0));
					const gridTemplateColumns = gridStyles.gridTemplateColumns;
					const gridTemplateRows = gridStyles.gridTemplateRows;

					// Function to check if an element is in the same "logical" row as the slider in the grid
					// In our grid-template: "prev slider next"
					// If the grid-template-columns has 3 columns and the slider is the middle one.
					const columnsCount = gridTemplateColumns.split(' ').length;

					// Only subtract button widths if they are in the same row as the slider.
					// We can check this by looking at the grid-template-areas or by checking if the slider
					// actually spans all columns (which it does in the responsive layout: "slider slider slider")
					const sliderSpansAll = gridStyles.gridTemplateAreas && gridStyles.gridTemplateAreas.includes('"slider slider slider"');

					if (columnsCount >= 3 && !sliderSpansAll) {
						if ($prev.length > 0 && $prev.is(':visible')) {
							buttonsWidth += $prev.outerWidth(true);
						}
						if ($next.length > 0 && $next.is(':visible')) {
							buttonsWidth += $next.outerWidth(true);
						}

						// Subtract gap if defined in grid
						const columnGap = parseFloat(gridStyles.columnGap) || 0;
						if (buttonsWidth > 0) {
							if ($prev.is(':visible') && $next.is(':visible')) {
								buttonsWidth += (columnGap * 2);
							} else {
								buttonsWidth += columnGap;
							}
						}
					}

					containerWidth -= buttonsWidth;

					// Subtract pagination height if present in grid
					const $pagination = $grid.find('.swiper-pagination');
					if ($pagination.length > 0 && $pagination.is(':visible')) {
						// According to SCSS, pagination is in a row with --pagination-height (default 5rem)
						let paginationRowHeightStr = getComputedStyle($grid.get(0)).getPropertyValue('--pagination-height').trim();
						let paginationRowHeight;
						if (paginationRowHeightStr.endsWith('rem')) {
							paginationRowHeight = parseFloat(paginationRowHeightStr) * parseFloat(getComputedStyle(document.documentElement).fontSize);
						} else if (paginationRowHeightStr.endsWith('px')) {
							paginationRowHeight = parseFloat(paginationRowHeightStr);
						} else {
							// Fallback if variable is not set or in other units, but checking if it's in the grid rows
							paginationRowHeight = parseFloat(getComputedStyle(document.documentElement).fontSize) * 5;
						}

						// In the responsive layout, prev/next are in the same row as pagination
						// grid-template: ... "prev pagination next" auto ...
						// If so, we should ensure we take the max height if buttons are taller,
						// but usually auto will follow the content.
						containerHeight -= paginationRowHeight;
					}

					// Subtract extra height for buttons row in responsive layout if not in the same row as slider
					if (sliderSpansAll) {
						// In responsive: "prev pagination next" auto
						// The pagination height subtraction above might already cover it if --pagination-height
						// matches that row. If not, we might need to check the buttons height.
						if ($prev.length > 0 && $prev.is(':visible') && !$pagination.is(':visible')) {
							containerHeight -= $prev.outerHeight(true);
						} else if ($next.length > 0 && $next.is(':visible') && !$pagination.is(':visible')) {
							containerHeight -= $next.outerHeight(true);
						}
					}

					// Subtract thumb height if in a flex container
					const $parentContainer = $grid.parent();
					if ($parentContainer.is('[class*="-flex"]')) {
						const $thumb = $parentContainer.find('.thumb');
						if ($thumb.length > 0 && $thumb.is(':visible')) {
							containerHeight -= $thumb.outerHeight(true);
						}
					}

					// Ensure containerHeight is not negative
					containerHeight = Math.max(0, containerHeight);

					let width, height;

					if (containerWidth / containerHeight > ratio) {
						// Container is wider than image ratio -> height is limiting
						height = containerHeight;
						width = height * ratio;

						// Safety check for width
						if (width > containerWidth) {
							width = containerWidth;
							height = width / ratio;
						}
					} else {
						// Container is narrower than image ratio -> width is limiting
						width = containerWidth;
						height = width / ratio;

						// Safety check for height
						if (height > containerHeight) {
							height = containerHeight;
							width = height * ratio;
						}
					}

					if (width > 0) {
						$grid.get(0).style.setProperty('--swiper-width', width + 'px');
						$grid.get(0).style.setProperty('--swiper-height', height + 'px');
					} else {
						$grid.get(0).style.removeProperty('--swiper-width');
						$grid.get(0).style.removeProperty('--swiper-height');
					}
				}
			}
		};

		// Initial update before slider creation
		updateSwiperWidth();

		const gridEvents = {
			resize: function() {
				updateSwiperWidth();
			},
		};

		Object.assign(events, gridEvents);
	}

	let sliderGalleryEl = new Slider(gallery, config, events);

	// Trigger breakpoint change for dynamical wrapper size
	sliderGalleryEl.updateSlider();

	if (!sliderGallery.includes(sliderGalleryEl)) {
		sliderGallery.push(sliderGalleryEl);
	}
};
const destroySliderGallery = function () {
	if (sliderGallery.length && typeof sliderGallery !== 'undefined') {
		for (var i = 0; i < sliderGallery.length; i++) {
			if (sliderGallery[i] && typeof sliderGallery[i] !== 'undefined' && typeof sliderGallery[i].destroy !== 'undefined') {
				sliderGallery[i].destroy();
				delete sliderGallery[i];
			}
		}
	}
}

// Article search slide view
window.searchSlider = [];
window.initSearchSlider = function (elem, box) {
	const config = {
		autoplay: false,
		loop: false,
		//rewind: true,
		slidesPerView: 1.56,
		slidesPerGroup: 1,
		spaceBetween: 20,
		grabCursor: true,
		lazyPreloadPrevNext: 2,
		breakpoints: {
			1441: {
				slidesPerView: 3.56,
				spaceBetween: 40,
			},
			1081: {
				slidesPerView: 2.56,
				spaceBetween: 40,
			},
			962: {
				slidesPerView: 3.56,
				spaceBetween: 30,
			},
			861: {
				slidesPerView: 3.56,
				spaceBetween: 30,
			},
			641: {
				slidesPerView: 2.56,
				spaceBetween: 30,
			},
			421: {
				slidesPerView: 1.56,
				spaceBetween: 20,
			},
		},
		scrollbar: {
			el: $(elem).find('> .swiper-controls .swiper-scrollbar').get(0),
			draggable: true,
			enabled: true,
		},
		navigation: {
			nextEl: $(elem).find('> .swiper-controls .swiper-button-next').first().get(0),
			prevEl: $(elem).find('> .swiper-controls .swiper-button-prev').first().get(0),
		},
		pagination: {
			el: $(elem).find('> .swiper-controls .swiper-pagination').get(0),
			type: 'fraction',
			renderFraction: function (currentClass, totalClass) {
				return '<div class="d-flex flex-row">' +
					'	<div class="swiper-pagination-current flex-grow-1 text-end ' + currentClass + '"></div>' +
					'	<div class="swiper-pagination-seperator">&nbsp;/&nbsp;</div>' +
					'	<div class="swiper-pagination-total  flex-grow-1 text-start ' + totalClass + '"></div>' +
					'</div>';
			}
		},
	};

	const events = {
		breakpoint: function(swiper) {
			if (typeof swiper.el !== 'undefined' && typeof swiper.slides !== 'undefined' && typeof window.searchSliderMaxHeaderHeight !== 'undefined') {
				window.searchSliderMaxHeaderHeight(swiper.el, swiper.slides);
			}
		},
		afterInit: function(swiper) {
			if (typeof swiper.el !== 'undefined' && typeof swiper.slides !== 'undefined' && typeof window.searchSliderMaxHeaderHeight !== 'undefined') {
				window.searchSliderMaxHeaderHeight(swiper.el, swiper.slides);
			}
		}
	}

	let searchSliderEl = new Slider(elem, config, events);

	if (typeof window.searchSlider === 'undefined') {
		window.searchSlider = [];
	}

	if (!window.searchSlider.includes(searchSliderEl)) {
		window.searchSlider.push(searchSliderEl);
	}
};

window.searchSliderMaxHeaderHeight = function (slider, slides) {
	if (typeof slider === 'undefined' || typeof slides === 'undefined') {
		return;
	}

	let maxHeaderHeight = 0;
	$(slides).each(function() {
		const headerEl = $(this).find('.articleheader');
		const headerHeight = headerEl.outerHeight();

		if (headerHeight > maxHeaderHeight) {
			maxHeaderHeight = headerHeight;
		}
	});

	$(slider).css('--search-item-header-max-height', `${maxHeaderHeight}px`);
}

// Thumbnail slider
window.thumbnailSlider = [];
window.initThumbnailSlider = function (elem, box) {
	const config = {
		autoplay: false,
		loop: false,
		grabCursor: true,
		allowTouchMove: true,
		slidesPerView: 1,
		spaceBetween: 15,
		navigation: {
			nextEl: $(elem).find('.swiper-button-next').first().get(0),
			prevEl: $(elem).find('.swiper-button-prev').first().get(0),
		},
		pagination: {
			el: $(elem).find('.swiper-pagination').get(0),
			type: 'fraction',
			renderFraction: function (currentClass, totalClass) {
				return '<div class="d-flex flex-row">' +
					'	<div class="swiper-pagination-current flex-grow-1 text-end ' + currentClass + '"></div>' +
					'	<div class="swiper-pagination-seperator">&nbsp;/&nbsp;</div>' +
					'	<div class="swiper-pagination-total  flex-grow-1 text-start ' + totalClass + '"></div>' +
					'</div>';
			}
		},
		breakpoints: {
			1801: {
				slidesPerView: 6,
				spaceBetween: 30,
				grabCursor: false,
				allowTouchMove: false,
			},
			1601: {
				slidesPerView: 6,
				spaceBetween: 30,
				grabCursor: false,
				allowTouchMove: false,
			},
			1441: {
				slidesPerView: 6,
				spaceBetween: 30,
				grabCursor: false,
				allowTouchMove: false,
			},
			1081: {
				slidesPerView: 5,
				spaceBetween: 30,
				grabCursor: false,
				allowTouchMove: false,
			},
			861: {
				slidesPerView: 4,
				spaceBetween: 20,
				grabCursor: false,
				allowTouchMove: false,
			},
			641: {
				slidesPerView: 3,
				spaceBetween: 20,
				grabCursor: false,
				allowTouchMove: false,
			},
			421: {
				slidesPerView: 1,
				spaceBetween: 15,
				grabCursor: true,
				allowTouchMove: true,
			},
		},
	};

	const events = {
		breakpoint(swiper, breakpointParams) {
			if (!swiper || !breakpointParams || !swiper.wrapperEl) return;

			const slides = Array.from(
				swiper.wrapperEl.querySelectorAll('.swiper-slide')
			);

			if (!slides.length) return;

			const realSlides = slides.filter(slide =>
				!slide.classList.contains('swiper-slide-duplicate')
			);

			if (!realSlides.length) return;

			const totalSlides = realSlides.length;

			let slidesPerView = breakpointParams.slidesPerView;
			if (!slidesPerView) return;

			slidesPerView = slidesPerView === 'auto'
				? swiper.slidesPerViewDynamic?.() || 1
				: parseInt(slidesPerView, 10);

			if (!slidesPerView || isNaN(slidesPerView)) return;

			slidesPerView = Math.min(slidesPerView, totalSlides);

			swiper.wrapperEl
				.querySelectorAll('.overlay.hasimage')
				.forEach(overlay => overlay.remove());

			const hiddenSlides = totalSlides - slidesPerView;
			if (hiddenSlides <= 0) return;

			const lastVisibleSlide = realSlides[slidesPerView - 1];
			if (!lastVisibleSlide) return;

			const overlay = document.createElement('div');
			overlay.className = 'overlay hasimage d-none d-md-flex align-items-center justify-content-center';
			overlay.textContent = `+${hiddenSlides} ${hiddenSlides === 1 ? strings.photo[lang] : strings.photos[lang]}`;

			lastVisibleSlide.appendChild(overlay);
		}
	};

	let thumbnailSliderEl = new Slider(elem, config, events);

	if (typeof window.thumbnailSlider === 'undefined') {
		window.thumbnailSlider = [];
	}

	if (!window.thumbnailSlider.includes(thumbnailSliderEl)) {
		window.thumbnailSlider.push(thumbnailSliderEl);
	}
}

// Videos
//

// Controller
window.Video = {
	init: function (elem, settings) {
		// get video type
		let videoType = Video.getVideoType($(elem).get(0));

		// go to action
		switch (videoType) {
			case 'html':
				Html5Video.init(elem, settings);
				break;
			case 'youtube':
				YouTubeVideo.init(elem, settings);
				break;
			case 'vimeo':
				VimeoVideo.init(elem, settings);
				break;
		}
	},
	play: function (elem, settings) {
		// get video type
		let videoType = Video.getVideoType($(elem).get(0));

		// go to action
		switch (videoType) {
			case 'html':
				Html5Video.play(elem, settings);
				break;
			case 'youtube':
				YouTubeVideo.play(elem, settings);
				break;
			case 'vimeo':
				VimeoVideo.play(elem, settings);
				break;
		}
	},
	pause: function (elem) {
		// get video type
		let videoType = Video.getVideoType(elem);

		// go to action
		switch (videoType) {
			case 'html':
				Html5Video.pause(elem);
				break;
			case 'youtube':
				YouTubeVideo.pause(elem);
				break;
			case 'vimeo':
				VimeoVideo.pause(elem);
				break;
		}
	},
	stop: function (elem) {
		// get video type
		let videoType = Video.getVideoType(elem);

		// go to action
		switch (videoType) {
			case 'html':
				Html5Video.stop(elem);
				break;
			case 'youtube':
				YouTubeVideo.stop(elem);
				break;
			case 'vimeo':
				VimeoVideo.stop(elem);
				break;
		}
	},
	mute: function (elem) {
		// get video type
		let videoType = Video.getVideoType(elem);
	},
	unmute: function (elem) {
		// get video type
		let videoType = Video.getVideoType(elem);
	},
	getVideoType: function (elem) {
		if ($(elem).length > 0) {
			if ($(elem).hasClass('youtube-iframe')) {
				return 'youtube';
			} else if ($(elem).hasClass('vimeo-iframe')) {
				return 'vimeo';
			} else if ($(elem).hasClass('html-video')) {
				return 'html';
			}
		}

		return false;
	},
}

// HTML5
window.Html5Video = {
	init: function (elem, settings) {
		// mark as initalized
		$(elem).addClass('init');

		// get required dom elements for player
		let playerContainer = $(elem).get(0);
		if (!$(playerContainer).hasClass('html-video')) {
			if ($(playerContainer).find('video.html-video').length <= 0) {
				return false;
			}
			playerContainer = $(elem).find('video.html-video').get(0);
		}

		// check if unique id is set
		if (!$(playerContainer).attr('id')) {
			console.warn('Html5 video logic needs a unique id on the video DOM element');
			return false;
		}

		let elemId = $(playerContainer).attr('id');

		// set status
		// set audio status
		let audioStatus = 1;
		if ($(playerContainer).attr('muted') && $(playerContainer).attr('muted') !== 'false') {
			audioStatus = 0;
		}

		// set play status
		let playStatus = 0;
		if ($(playerContainer).attr('autoplay') && $(playerContainer).attr('autoplay') !== 'false') {
			playStatus = 1;
			audioStatus = 0;
		}

		// get parent container
		let parentContainer;
		if ($(elem).closest('.video-container.html-video-container').length > 0) {
			parentContainer = $(elem).closest('.video-container.html-video-container');
		}

		// get controls
		let controls;
		if ($(parentContainer).length > 0 && $(parentContainer).find('.video-controls.html-video-controls').length > 0) {
			controls = $(parentContainer).find('.video-controls.html-video-controls');
			if ($(playerContainer).attr('controls') && $(playerContainer).attr('controls') !== 'false') {
				$(controls).remove();
			}
		}

		// get play button
		let playButton;
		if ($(controls).length > 0 && $(controls).find('.video-play.html-video-play').length > 0) {
			playButton = $(controls).find('.video-play.html-video-play');
			if (playStatus === 0) {
				$(playButton).addClass('paused');
			} else {
				$(playButton).removeClass('paused');
			}
		}

		// set event listener on button
		if ($(playButton).length > 0) {
			$(playButton).on('click', function () {
				Html5Video.togglePlayStatus(elem);
			}).on('keydown', function (e) {
				// Enter
				if (e.key === 'Enter') {
					e.preventDefault();
					$(this).trigger('click');
				}
			});
		}

		// get audio button
		let audioButton;
		if ($(controls).length > 0 && $(controls).find('.video-audio.html-video-audio').length > 0) {
			audioButton = $(controls).find('.video-audio.html-video-audio');
			if (audioStatus === 0) {
				$(audioButton).addClass('muted');
			}
		}

		// set event listener on button
		if ($(audioButton).length > 0) {
			$(audioButton).on('click', function () {
				Html5Video.toggleSound(elem);
			}).on('keydown', function (e) {
				// Enter
				if (e.key === 'Enter') {
					e.preventDefault();
					$(this).trigger('click');
				}
			});
		}

		// set default callbacks for updating status
		let defaultCallbacks = {
			'play': function () {
				if (typeof Html5Video.storage[elemId] !== 'undefined') {
					Html5Video.storage[elemId]['playStatus'] = 1;
					if (typeof Html5Video.storage[elemId]['playButton'] !== 'undefined') {
						$(Html5Video.storage[elemId]['playButton']).removeClass('paused visible');
					}
				}
			},
			'pause': function () {
				if (typeof Html5Video.storage[elemId] !== 'undefined') {
					Html5Video.storage[elemId]['playStatus'] = 2;
					if (typeof Html5Video.storage[elemId]['playButton'] !== 'undefined') {
						$(Html5Video.storage[elemId]['playButton']).addClass('paused visible');
					}
				}
			},
			'stop': function () {
				if (typeof Html5Video.storage[elemId] !== 'undefined') {
					Html5Video.storage[elemId]['playStatus'] = 0;
					if (typeof Html5Video.storage[elemId]['playButton'] !== 'undefined') {
						$(Html5Video.storage[elemId]['playButton']).addClass('paused visible');
					}
				}
			},
			'ended': function () {
				if (typeof Html5Video.storage[elemId] !== 'undefined') {
					Html5Video.storage[elemId]['playStatus'] = 0;
					if (typeof Html5Video.storage[elemId]['playButton'] !== 'undefined') {
						$(Html5Video.storage[elemId]['playButton']).addClass('paused visible');
					}
				}
			},
		}

		// set default callbacks
		Html5Video.setCallback(elem, defaultCallbacks);

		// check & set for callbacks
		if (typeof settings !== 'undefined' && typeof settings.callback !== 'undefined') {
			Html5Video.setCallback(elem, settings.callback);
		}

		// save player in storage
		Html5Video.storage[elemId] = {
			elem: elem,
			settings: settings,
			playStatus: playStatus,
			audioStatus: audioStatus,
			playButton: playButton,
			audioButton: audioButton,
		};

		return elem;
	},
	togglePlayStatus: function (elem) {
		if (!elem) {
			return false;
		}

		// get player
		let player = Html5Video.getPlayer(elem);
		if (!player) {
			return false;
		}

		if (typeof player.playStatus !== 'undefined') {
			if (player.playStatus === -1 || player.playStatus === 0 || player.playStatus === 2) {
				Html5Video.play(elem);
			} else {
				Html5Video.pause(elem);
			}
		}
	},
	play: function (elem, settings = {}) {
		// init if not happend
		if (!$(elem).hasClass('init')) {
			elem = Html5Video.init(elem, settings);
			return;
		}

		$(elem).addClass('playing played');

		// trigger play
		$(elem).trigger('play');
	},
	pause: function (elem) {
		$(elem).trigger('pause');

		$(elem).removeClass('playing');
	},
	stop: function (elem) {
		$(elem).trigger('stop');

		$(elem).removeClass('playing');
	},
	toggleSound: function (elem) {
		if (!elem) {
			return false;
		}

		// get player
		let player = Html5Video.getPlayer(elem);
		if (!player) {
			return false;
		}

		if (typeof player.audioStatus !== 'undefined') {
			if (player.audioStatus === 0) {
				Html5Video.unmute(elem);
			} else {
				Html5Video.mute(elem);
			}
		}
	},
	mute: function (elem) {
		if (!elem) {
			return false;
		}

		// get player
		let player = Html5Video.getPlayer(elem);
		if (!player) {
			return false;
		}

		if (typeof player.elem !== 'undefined' && $(player.elem).length > 0) {
			let elemId = $(player.elem).attr('id');
			$(player.elem).prop('muted', true);
			if (typeof player.audioButton !== 'undefined' && $(player.audioButton).length > 0) {
				$(player.audioButton).addClass('muted');
			}
			Html5Video.storage[elemId]['audioStatus'] = 0;
		}
	},
	unmute: function (elem) {
		if (!elem) {
			return false;
		}

		// get player
		let player = Html5Video.getPlayer(elem);
		if (!player) {
			return false;
		}

		if (typeof player.elem !== 'undefined' && $(player.elem).length > 0) {
			let elemId = $(player.elem).attr('id');
			$(player.elem).prop('muted', false);
			if (typeof player.audioButton !== 'undefined' && $(player.audioButton).length > 0) {
				$(player.audioButton).removeClass('muted');
			}
			Html5Video.storage[elemId]['audioStatus'] = 1;
		}
	},
	setCallback: function (elem, callbacks) {
		for (const callback in callbacks) {
			switch (callback) {
				case 'play':
				case 'playing':
					if (typeof callbacks[callback] === 'function') {
						$(elem).bind('play', callbacks[callback]);
					}
					break;
				case 'pause':
				case 'paused':
					if (typeof callbacks[callback] === 'function') {
						$(elem).bind('pause', callbacks[callback]);
					}
					break;
				case 'stop':
				case 'ended':
					if (typeof callbacks[callback] === 'function') {
						$(elem).bind('ended', callbacks[callback]);
					}
					break;
			}
		}
	},
	getPlayer: function (elem) {
		if (!elem) {
			return false;
		}

		// get required dom elements for player
		let playerContainer = $(elem).get(0);
		if (!$(playerContainer).hasClass('html-video')) {
			if ($(playerContainer).find('video.html-video').length <= 0) {
				return false;
			}
			playerContainer = $(elem).find('video.html-video').get(0);
		}

		// check if unique id is set
		if (!$(playerContainer).attr('id')) {
			console.warn('Html5 video logic needs a unique id on the video DOM element');
			return false;
		}

		let elemId = $(playerContainer).attr('id');

		if (Html5Video.storage[elemId]) {
			return Html5Video.storage[elemId];
		}
		return false;
	},
	storage: [],
}

// YouTube
window.YouTubeVideo = {
	init: function (elem, settings = {}) {
		// check youtube api status
		if (typeof youtubeApiLoaded === 'undefined' || youtubeApiLoaded === false) {
			YouTubeVideo.setToWaitingList(elem, settings);
			return false;
		}

		// mark as initalized
		$(elem).addClass('init');

		// get required dom elements for player
		let playerContainer = $(elem).get(0);
		if (!$(playerContainer).hasClass('youtube-iframe')) {
			if ($(playerContainer).find('.youtube-iframe').length <= 0) {
				return false;
			}
			playerContainer = $(elem).find('.youtube-iframe').get(0);
		}

		// check if unique id is set
		if (!$(playerContainer).attr('id')) {
			console.warn('YouTube JavaScript API needs a unique id on the video DOM element');
			return false;
		}

		let elemId = $(playerContainer).attr('id');

		// default settings
		let autoplay = 0;
		let controls = 0;
		let playsinline = 1;
		let loop = 0;
		let muted = 0;

		// override settings by attributes
		if ($(playerContainer).attr('autoplay') && $(playerContainer).attr('autoplay') !== 'false') {
			autoplay = 1;
			muted = 1;

			$(elem).addClass('playing played');
		}
		if ($(playerContainer).attr('controls')) {
			controls = 1;
		}
		/*
		if ($(playerContainer).attr('playsinline') && $(playerContainer).attr('playsinline') !== 'false') {
			playsinline = 1;
		}
		*/
		if ($(playerContainer).attr('loop') && $(playerContainer).attr('loop') !== 'false') {
			loop = 1;
		}
		if ($(playerContainer).attr('muted') && $(playerContainer).attr('muted') !== 'false') {
			muted = 1;
		}

		// get parent container
		let parentContainer;
		if ($(elem).closest('.video-container.youtube-video-container').length > 0) {
			parentContainer = $(elem).closest('.video-container.youtube-video-container');
		}

		// get controls
		let controlElements;
		if ($(parentContainer).length > 0 && $(parentContainer).find('.video-controls.youtube-video-controls').length > 0) {
			controlElements = $(parentContainer).find('.video-controls.youtube-video-controls');
			if ($(playerContainer).attr('controls') && $(playerContainer).attr('controls') !== 'false') {
				//$(controlElements).remove();
				$(playerContainer).addClass('hide-custom-controls');
			}
		}

		// get play button
		let playButton;
		if ($(controlElements).length > 0 && $(controlElements).find('.video-play.youtube-video-play').length > 0) {
			playButton = $(controlElements).find('.video-play.youtube-video-play');
			if (autoplay === 0) {
				$(playButton).addClass('paused');
			} else {
				$(playButton).removeClass('paused');
			}
		}

		// set event listener on button
		if ($(playButton).length > 0) {
			$(playButton).on('click', function () {
				YouTubeVideo.togglePlayStatus($('#' + elemId));
			}).on('keydown', function (e) {
				// Enter
				if (e.key === 'Enter') {
					e.preventDefault();
					$(this).trigger('click');
				}
			});
		}

		// get audio button
		let audioButton;
		if ($(controlElements).length > 0 && $(controlElements).find('.video-audio.youtube-video-audio').length > 0) {
			audioButton = $(controlElements).find('.video-audio.youtube-video-audio');
			if (muted === 1) {
				$(audioButton).addClass('muted');
			}
		}

		// set event listener on button
		if ($(audioButton).length > 0) {
			$(audioButton).on('click', function () {
				YouTubeVideo.toggleSound($('#' + elemId));
			}).on('keydown', function (e) {
				// Enter
				if (e.key === 'Enter') {
					e.preventDefault();
					$(this).trigger('click');
				}
			});
		}

		// init player
		let player = new YT.Player(playerContainer, {
			playerVars: {
				'autoplay': autoplay,
				'modestbranding': 1,
				'controls': controls,
				'rel': 0,
				'showinfo': 0,
				'playsinline': playsinline,
				'loop': loop,
				'mute': muted,
			},
			videoId: playerContainer.dataset.id,
			events: {
				'onReady': function(e) {
					// You can perform any actions you want when the player is ready here
				},
				'onStateChange': function (e) {
					// check for callbacks
					// @todo: fix swiper bug: when in slider and loop is enabled, error "Failed to execute 'postMessage' on 'DOMWindow'" / maybe destroy yt video and init it again when loop will pass or disable automaticaly the loop
					if (typeof settings.callback !== 'undefined') {
						// playing (1)
						if (e.data === YT.PlayerState.PLAYING) {
							if (typeof settings.callback.play !== 'undefined' && typeof settings.callback.play === 'function') {
								settings.callback.play();
							}

							if ($(playButton).length > 0) {
								$(playButton).removeClass('paused visible');
							}
						}
						// paused (2)
						if (e.data === YT.PlayerState.PAUSED) {
							if (typeof settings.callback.paused !== 'undefined' && typeof settings.callback.paused === 'function') {
								settings.callback.paused();
							}

							if ($(playButton).length > 0) {
								$(playButton).addClass('paused visible');
							}
						}
						// cued/popsitioned (5)
						if (e.data === YT.PlayerState.CUED) {
							if (typeof settings.callback.cued !== 'undefined' && typeof settings.callback.cued === 'function') {
								settings.callback.cued();
							}
						}
						// ended (0)
						if (e.data === YT.PlayerState.ENDED) {
							if (typeof settings.callback.ended !== 'undefined' && typeof settings.callback.ended === 'function') {
								settings.callback.ended();
							}

							if ($(playButton).length > 0) {
								$(playButton).addClass('paused visible');
							}

							if (loop === 1) {
								e.target.playVideo();
							}
						}
					}
				},
			},
		});

		// safe player to storage
		YouTubeVideo.storage.push(player);

		// set iframe as elem
		elem = $(player.g);

		return elem;
	},
	togglePlayStatus: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (typeof player.pauseVideo === 'function' && typeof player.getPlayerState === 'function') {
			if (player.getPlayerState() === -1 || player.getPlayerState() === 0 || player.getPlayerState() === 2 || player.getPlayerState() === 5) {
				YouTubeVideo.play(elem);
			} else {
				YouTubeVideo.pause(elem);
			}
		}
	},
	play: function (elem, settings = {}) {
		// init if not happend
		if (!$(elem).hasClass('init')) {
			elem = YouTubeVideo.init(elem, settings);
			return false;
		}

		$(elem).addClass('playing played');

		// return false without elem
		if (elem === false) {
			return false;
		}

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (player && typeof player.playVideo === 'function') {
			player.playVideo();
		}
	},
	pause: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		$(elem).removeClass('playing');

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (typeof player.pauseVideo === 'function' && typeof player.getPlayerState === 'function') {
			if (player.getPlayerState() === 1) {
				player.pauseVideo();
			}
		}
	},
	stop: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		$(elem).removeClass('playing');

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (typeof player.stopVideo === 'function' && typeof player.getPlayerState === 'function') {
			if (player.getPlayerState() === 1 || player.getPlayerState() === 2) {
				player.stopVideo();
			}
		}
	},
	destroy: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		$(elem).removeClass('playing');

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (typeof player.destroy === 'function') {
			if (typeof player.o !== 'undefined' && $(player.o).length > 0) {
				$(player.o).removeClass('init');
			}
			player.destroy();
		}
	},
	toggleSound: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (typeof player.isMuted === 'function') {
			if (player.isMuted()) {
				YouTubeVideo.unmute(elem);
			} else {
				YouTubeVideo.mute(elem);
			}
		}
	},
	mute: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (typeof player.mute === 'function') {
			player.mute();

			// get audio control
			let audioControl;
			if ($(elem).find('.video-audio.youtube-video-audio').length > 0) {
				audioControl = $(elem).find('.video-audio.youtube-video-audio');
			} else if ($(elem).closest('.video-container.youtube-video-container').find('.video-audio.youtube-video-audio').length > 0) {
				audioControl = $(elem).closest('.video-container.youtube-video-container').find('.video-audio.youtube-video-audio');
			}

			// if audio control exist, add muted class
			if ($(audioControl).length > 0) {
				$(audioControl).addClass('muted');
			}
		}
	},
	unmute: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (typeof player.unMute === 'function') {
			player.unMute();
		}

		// get audio control
		let audioControl;
		if ($(elem).find('.video-audio.youtube-video-audio').length > 0) {
			audioControl = $(elem).find('.video-audio.youtube-video-audio');
		} else if ($(elem).closest('.video-container.youtube-video-container').find('.video-audio.youtube-video-audio').length > 0) {
			audioControl = $(elem).closest('.video-container.youtube-video-container').find('.video-audio.youtube-video-audio');
		}

		// if audio control exist, remove muted class
		if ($(audioControl).length > 0) {
			$(audioControl).removeClass('muted');
		}
	},
	setToWaitingList: function (elem, settings) {
		let id = $(elem).attr('id');
		if (id) {
			let exists = YouTubeVideo.waitingList.some(video => video.id === id);
			if (!exists) {
				YouTubeVideo.waitingList.push({id, settings});
			}
		}
	},
	processAllVideos: function () {
		while (YouTubeVideo.waitingList.length > 0) {
			let video = YouTubeVideo.waitingList.shift();
			let id = video['id'];
			let elem = $('#' + id);
			let settings = {};
			if (video['settings']) {
				settings = video['settings'];
			}
			if (elem.length > 0) {
				YouTubeVideo.init(elem, settings);
			}
		}
	},
	getPlayer: function (elem) {
		if ($(elem).attr('id').length > 0) {
			return YT.get($(elem).attr('id'));
		}
		return false;
	},
	waitingList: [],
	callbacks: [],
	storage: [],
}

window.onYouTubeIframeAPIReady = function() {
	window.youtubeApiLoaded = true;
	if (typeof window.YouTubeVideo.processAllVideos === 'function') {
		window.YouTubeVideo.processAllVideos();
	}
}

// Vimeo
window.VimeoVideo = {
	init: function (elem, settings) {
		// check vimeo api status
		if (typeof vimeoApiLoaded === 'undefined' || vimeoApiLoaded === false) {
			VimeoVideo.setToWaitingList(elem, settings);
			return false;
		}

		// mark as initalized
		$(elem).addClass('init');

		// get player
		let player = VimeoVideo.getPlayer(elem);
		if (!player) {
			return;
		}

		// player container
		if (!player.element) {
			return false;
		}
		let playerContainer = player.element;

		// get parent container
		let parentContainer;
		if ($(elem).closest('.video-container.vimeo-video-container').length > 0) {
			parentContainer = $(elem).closest('.video-container.vimeo-video-container');
		};

		// default settings
		let autoplay = 0;
		let controls = 0;
		let playsinline = 0;
		let loop = 0;
		let muted = 0;

		// override settings by attributes
		if ($(playerContainer).attr('autoplay') && $(playerContainer).attr('autoplay') !== 'false') {
			autoplay = 1;
			muted = 1;
		}
		if ($(playerContainer).attr('controls')) {
			controls = 1;
		}
		if ($(playerContainer).attr('playsinline') && $(playerContainer).attr('playsinline') !== 'false') {
			playsinline = 1;
		}
		if ($(playerContainer).attr('loop') && $(playerContainer).attr('loop') !== 'false') {
			loop = 1;
		}
		if ($(playerContainer).attr('muted') && $(playerContainer).attr('muted') !== 'false') {
			muted = 1;
		}

		// get controls
		let controlElements;
		if ($(parentContainer).length > 0 && $(parentContainer).find('.video-controls.vimeo-video-controls').length > 0) {
			controlElements = $(parentContainer).find('.video-controls.vimeo-video-controls');
			if ($(playerContainer).attr('controls') && $(playerContainer).attr('controls') !== 'false') {
				//$(controlElements).remove();
				$(playerContainer).addClass('hide-custom-controls');
			}
		}

		// get play button
		let playButton;
		if ($(controlElements).length > 0 && $(controlElements).find('.video-play.vimeo-video-play').length > 0) {
			playButton = $(controlElements).find('.video-play.vimeo-video-play');
			if (autoplay === 0) {
				if (playButton) {
					$(playButton).addClass('paused');
				}
			} else {
				$(playButton).removeClass('paused');
			}
		}

		// set event listener on button
		if ($(playButton).length > 0) {
			$(playButton).on('click', function () {
				VimeoVideo.togglePlayStatus(elem);
			}).on('keydown', function (e) {
				// Enter
				if (e.key === 'Enter') {
					e.preventDefault();
					$(this).trigger('click');
				}
			});
		}

		// get audio button
		let audioButton;
		if ($(controlElements).length > 0 && $(controlElements).find('.video-audio.vimeo-video-audio').length > 0) {
			audioButton = $(controlElements).find('.video-audio.vimeo-video-audio');
			if (muted === 1) {
				VimeoVideo.mute(elem);
			}
		}

		// set event listener on button
		if ($(audioButton).length > 0) {
			$(audioButton).on('click', function () {
				VimeoVideo.toggleSound(elem);
			}).on('keydown', function (e) {
				// Enter
				if (e.key === 'Enter') {
					e.preventDefault();
					$(this).trigger('click');
				}
			});
		}

		// callbacks
		// ended
		if (typeof settings.callback.ended !== 'undefined' && typeof settings.callback.ended === 'function') {
			player.on('ended', function(data) {
				settings.callback.ended();
			});
		}

		return elem;
	},
	togglePlayStatus: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		let player = VimeoVideo.getPlayer(elem);
		if (!player) {
			return false;
		}

		player.getPaused().then(function (paused) {
			if (paused) {
				VimeoVideo.play(elem);
			} else {
				VimeoVideo.pause(elem);
			}
		});
	},
	play: function (elem, settings = {}) {
		// init if not happend
		if (!$(elem).hasClass('init')) {
			elem = VimeoVideo.init(elem, settings);
		}

		$(elem).addClass('playing played');

		// return false without elem
		if (elem === false) {
			return false;
		}

		// get video player
		let player = VimeoVideo.getPlayer(elem);
		if (!player) {
			return;
		}

		// play video
		player.getPaused().then(function(paused) {
			let playButton;
			if ($(elem).find('.video-play.vimeo-video-play').length > 0) {
				playButton = $(elem).find('.video-play.vimeo-video-play');
			} else if ($(elem).closest('.video-container.vimeo-video-container').find('.video-play.vimeo-video-play').length > 0) {
				playButton = $(elem).closest('.video-container.vimeo-video-container').find('.video-play.vimeo-video-play');
			}

			if (paused) {
				player.play();
				if (playButton.length) {
					playButton.removeClass('paused');
				}
			}
		});
	},
	pause: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		$(elem).removeClass('playing');

		// get video player
		let player = VimeoVideo.getPlayer(elem);
		if (!player) {
			return;
		}

		if (typeof player.getPaused === 'function') {
			let playButton;
			if ($(elem).find('.video-play.vimeo-video-play').length > 0) {
				playButton = $(elem).find('.video-play.vimeo-video-play');
			} else if ($(elem).closest('.video-container.vimeo-video-container').find('.video-play.vimeo-video-play').length > 0) {
				playButton = $(elem).closest('.video-container.vimeo-video-container').find('.video-play.vimeo-video-play');
			}

			// pause video
			player.getPaused().then(function(paused) {
				if (!paused) {
					player.pause();

					if (playButton.length) {
						playButton.addClass('paused');
					}
				}
			});
		}
	},
	stop: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		$(elem).removeClass('playing');
	},
	toggleSound: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		let player = VimeoVideo.getPlayer(elem);
		if (!player) {
			return false;
		}

		if (typeof player.getMuted === 'function') {
			player.getMuted().then(function (isMuted) {
				if (isMuted) {
					VimeoVideo.unmute(elem);
				} else {
					VimeoVideo.mute(elem);
				}
			});
		}
	},
	mute: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		let player = VimeoVideo.getPlayer(elem);
		if (!player) {
			return false;
		}

		if (typeof player.setMuted === 'function') {
			let audioControl;
			if ($(elem).find('.video-audio.vimeo-video-audio').length > 0) {
				audioControl = $(elem).find('.video-audio.vimeo-video-audio');
			} else if ($(elem).closest('.video-container.vimeo-video-container').find('.video-audio.vimeo-video-audio').length > 0) {
				audioControl = $(elem).closest('.video-container.vimeo-video-container').find('.video-audio.vimeo-video-audio');
			}

			player.setMuted(true).then(function () {
				if (audioControl.length) {
					audioControl.addClass('muted');
				}
			});
		}
	},
	unmute: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		let player = VimeoVideo.getPlayer(elem);
		if (!player) {
			return false;
		}

		if (typeof player.setMuted === 'function') {
			let audioControl;
			if ($(elem).find('.video-audio.vimeo-video-audio').length > 0) {
				audioControl = $(elem).find('.video-audio.vimeo-video-audio');
			} else if ($(elem).closest('.video-container.vimeo-video-container').find('.video-audio.vimeo-video-audio').length > 0) {
				audioControl = $(elem).closest('.video-container.vimeo-video-container').find('.video-audio.vimeo-video-audio');
			}

			player.setMuted(false).then(function () {
				if (audioControl.length) {
					audioControl.removeClass('muted');
				}
			});
		}
	},
	setToWaitingList: function (elem, settings) {
		let id = $(elem).attr('id');
		if (id) {
			let exists = VimeoVideo.waitingList.some(video => video.id === id);
			if (!exists) {
				VimeoVideo.waitingList.push({id, settings});
			}
		}
	},
	processAllVideos: function () {
		while (VimeoVideo.waitingList.length > 0) {
			let video = VimeoVideo.waitingList.shift();
			let id = video['id'];
			let elem = $('#' + id);
			let settings = {};
			if (video['settings']) {
				settings = video['settings'];
			}
			if (elem.length > 0) {
				VimeoVideo.init(elem, settings);
			}
		}
	},
	getPlayer: function (elem, settings) {
		if (typeof Vimeo === 'undefined') {
			return false;
		}

		// get player dom elements
		let playerContainer = $(elem).get(0);
		if (!$(playerContainer).hasClass('vimeo-iframe')) {
			if ($(playerContainer).find('.vimeo-iframe').length <= 0) {
				return false;
			}
			playerContainer = $(elem).find('.vimeo-iframe').get(0);
		}

		// get player id
		let dataVimeoId;
		let dataVimeoUrl;
		if ($(playerContainer).attr('data-vimeo-id') && $(playerContainer).attr('data-vimeo-id') !== '') {
			dataVimeoId = $(playerContainer).attr('data-vimeo-id');
		} else if ($(playerContainer).attr('src') && $(playerContainer).attr('src') !== '') {
			dataVimeoUrl = $(playerContainer).attr('src').split('/');
			if (typeof dataVimeoUrl === 'object') {
				dataVimeoId = dataVimeoUrl.slice(-1)[0];
			}
		} else if ($(playerContainer).attr('data-src') && $(playerContainer).attr('data-src') !== '') {
			dataVimeoUrl = $(playerContainer).attr('data-src').split('/');
			if (typeof dataVimeoUrl === 'object') {
				dataVimeoId = dataVimeoUrl.slice(-1)[0];
			}
		}

		if (!dataVimeoId) {
			console.warn('No vimeo video id', playerContainer);
			return false;
		}

		// check if unique id is set
		if (!$(playerContainer).attr('id')) {
			console.warn('YouTube JavaScript API needs a unique id on the video DOM element');
			return false;
		}

		let elemId = $(playerContainer).attr('id');

		// default settings
		let autoplay = false;
		let controls = false;
		let playsinline = true;
		let loop = false;
		let muted = true;

		// override settings by attributes
		if ($(playerContainer).attr('autoplay') && $(playerContainer).attr('autoplay') !== 'false') {
			autoplay = true;
			muted = true;
		}
		if ($(playerContainer).attr('controls')) {
			controls = true;
		}
		if ($(playerContainer).attr('playsinline') && $(playerContainer).attr('playsinline') === 'false') {
			playsinline = false;
		}
		if ($(playerContainer).attr('loop') && $(playerContainer).attr('loop') !== 'false') {
			loop = true;
		}
		if ($(playerContainer).attr('muted') && $(playerContainer).attr('muted') !== 'false') {
			muted = true;
		}

		// options
		let options = {
			autoplay: autoplay,
			controls: controls,
			loop: loop,
			muted: muted,
		};

		let player = new Vimeo.Player(playerContainer, options);

		return player;
	},
	waitingList: [],
	callbacks: [],
	storage: [],
}

// Fullscreen menu
//

// Open
function openFullscreenMenu(el, toggle) {
	if ($(el).data('closeTimer')) {
		clearTimeout($(el).data('closeTimer'));
		$(el).data('closeTimer', null);
	}
	$(el).show(0, function () {
		$(el).addClass('is-open');
	});
	$(toggle).addClass('is-open').attr({'aria-expanded': true});
}

// Close
function closeAllOpenFullscreenMenus() {
	const fullscreenMenu = $('.fullscreenmenu.is-open');
	if (fullscreenMenu && $(fullscreenMenu).length > 0) {
		$(fullscreenMenu).each(function() {
			const el = $(this);
			const elId = $(el).attr('id');
			if (!elId) return false;
			const toggle = $('.fullscreenmenu-toggle[data-toggle="#' + elId + '"]');
			if (toggle && $(toggle).length > 0) {
				closeFullscreenMenu(el, toggle);
			}
		});
	}
}

function closeFullscreenMenu(el, toggle) {
	$(el).removeClass('is-open');

	if ($(el).data('closeTimer')) {
		clearTimeout($(el).data('closeTimer'));
	}

	// Timeout have to e the same like the closing transition duration & delay
	const closeTimer = setTimeout(function () {
		$(el).hide(0);
		$(el).data('closeTimer', null);
	}, 500);

	$(el).data('closeTimer', closeTimer);
	$(toggle).removeClass('is-open').attr({'aria-expanded': false});
}


// Menu
//

// Open
function openMenu(timeout = 100) {
	if (window.closeMenuTimer) {
		window.clearTimeout(window.closeMenuTimer);
		window.closeMenuTimer = null;
	}
	if (window.openMenuTimer) {
		window.clearTimeout(window.openMenuTimer);
	}

	window.openMenuTimer = setTimeout(function () {
		$('html').addClass('scrollprevent');
		$('body').addClass('menuopen').removeClass('menuclosed');

		menuToggleCallback();
		window.openMenuTimer = null;
	}, timeout);
}

// Close
function closeMenu(anchor) {
	if (window.openMenuTimer) {
		window.clearTimeout(window.openMenuTimer);
		window.openMenuTimer = null;
	}
	if (window.closeMenuTimer) {
		window.clearTimeout(window.closeMenuTimer);
	}

	$('html').removeClass('scrollprevent');
	$('body').removeClass('menuopen').addClass('menuclosed');

	window.closeMenuTimer = setTimeout(function () {
		$('body').removeClass('menuclosed');
		window.closeMenuTimer = null;
	}, 400);

	menuToggleCallback();
}

// Toggle
function menuToggleCallback() {
	setTimeout(function() {
		if (typeof window.bLazy?.revalidate === 'function') {
			window.bLazy.revalidate();
		}
	}, 500);
}

// Navigation
//

// Main nav
//

// Open
function openMainNavItem(el) {
	$(el).closest('ul').find('> li.is-open').removeClass('is-open');
	$(el).closest('li').addClass('is-open');
}

// Close
function closeAllMainNavItems() {
	$('.mainnav').each(function () {
		$(this).find('.is-open').removeClass('is-open');
	});
}


// Tabs
//

let preselectedTabItem;
function initTabs (elem, box) {
	// check if tab was preselected in url
	if(location.hash !== '' && location.hash.indexOf("!") < 0) {
		let tabName = location.hash.replace("#", "");
		let tabItem = $('.tab-item[data-tab="' + tabName + '"]');
		if ($(tabItem).length > 0) {
			preselectedTabItem = $(tabItem);
		}
	} else if (location.href !== '' && typeof getURLParameter(location.href, 'tab') !== 'undefined') {
		let tabName = getURLParameter(location.href, 'tab');
		let tabItem = $('.tab-item[data-tab="' + tabName + '"]');
		if ($(tabItem).length > 0) {
			preselectedTabItem = $(tabItem);
		}
	}

	// preselect tabs
	$(elem, box).each(function () {
		if (typeof $(this).find(preselectedTabItem) !== 'undefined' && $(this).find(preselectedTabItem).length > 0) {
			var preselectedItem = $(this).find(preselectedTabItem).first();
			if (typeof preselectedItem !== 'undefined' && $(preselectedItem).length > 0) {
				$(preselectedItem).addClass('active-tab');
				var tabName = $(preselectedItem).attr('data-tab');
				var tabNavAnchor = $('body').find('a[data-tab="' + tabName + '"]');
				if ($(tabNavAnchor).closest('li, .swiper-slide').length && !$(tabNavAnchor).closest('li, .swiper-slide').hasClass('active') && !$(elem).closest('nav').hasClass('mainnav')) {
					$(tabNavAnchor).closest('li, .swiper-slide').addClass('active');
				}
			}
		} else if ($(this).find('.tabs-wrapper .tab-item.active-tab').length <= 0 && !$(this).hasClass('menutabs')) {
			let firstItem = $(this).find('.tabs-wrapper .tab-item').first();
			if (typeof firstItem !== 'undefined' && $(firstItem).length > 0) {
				$(firstItem).addClass('active-tab');
				let tabName = $(firstItem).attr('data-tab');
				let tabNavAnchor = $('body').find('a[data-tab="' + tabName + '"]');
				if ($(tabNavAnchor).closest('li, .swiper-slide').length && !$(tabNavAnchor).closest('li, .swiper-slide').hasClass('active') && !$(elem).closest('nav').hasClass('mainnav')) {
					$(tabNavAnchor).closest('li, .swiper-slide').addClass('active');
				}
			}
		}
	});
	$('a[data-tab]', box).click(function (e) {
		e.preventDefault();
		changeTab($(this));
		changeTabCallback($(this).closest('.tabs-container'));
		scroll();
	});
	/*
	$(elem, box).on('click', 'a[data-tab]', function(e) {
		e.preventDefault();
		changeTab($(this));
		changeTabCallback($(this).closest('.tabs-container'));
		scroll();
	});
	*/
	changeTabCallback($(elem, box));
	$(elem).find('.tabs-nav .add', box).click(function() {
		addTabLabel($(this).closest('.tabs-container'));
	});
	$(elem, box).on('click', '.tabs-nav .remove', function() {
		removeTabLabel($(this).closest('li'));
	});
	addRemoveLabelCallback($(this).closest('.tabs-container'));
	/*
	$(elem).find('.tabs-nav .remove', box).click(function() {
		removeTabLabel($(this).closest('li'));
	});
	if (tabsInitialized === false) {
	}
	tabsInitialized = true;
	*/
}

function initTabNavigationSlider (elem) {
	if (typeof Slider === 'undefined' && elem.closest('.swiper-container').length === 0) {
		return;
	}

	const config = {
		autoplay: false,
		slidesPerView: 'auto',
		spaceBetween: 10,
		slidesPerGroup: 1,
	};

	const tabsSlider = new Slider($(elem), config);
}

function changeTab (elem) {
	if (typeof $(elem).attr('data-tab') !== 'undefined') {
		let tabName = $(elem).attr('data-tab');
		let tab = $('.tab-item[data-tab="' + tabName + '"]');
		if ($(elem).closest('li, .swiper-slide').length && !$(elem).closest('li, .swiper-slide').hasClass('active') && !$(elem).closest('nav').hasClass('mainnav')) {
			if ($(elem).closest('ul, .swiper-wrapper').length) {
				$(elem).closest('ul, .swiper-wrapper').find('li.active, .swiper-slide.active').removeClass('active');
			}
			$(elem).parent('li, .swiper-slide').addClass('active');
		}
		let parentWrapper = $(tab).closest('.tabs-wrapper');
		if ($(tab).length > 0 && !$(tab).hasClass('active-tab')) {
			if ($(parentWrapper).length > 0) {
				$('.tab-item', parentWrapper).removeClass('active-tab');
			}
			$(tab).addClass('active-tab');
		} else if ($(tab).length <= 0) {
			console.warn("Tab \'" + tabName + "\' doesn't exist!");
			return false;
		}
	} else {
		return false;
	}
	if (typeof window.bLazy?.revalidate === 'function') {
		window.bLazy.revalidate();
	}
}

function changeTabCallback(tabsContainer, submitform) {
	if(typeof submitform === 'undefined') {
		submitform = false;
	}
	let currentTab = $(tabsContainer).find('.tabs-nav ul li').index($(tabsContainer).find('.tabs-nav ul li.active'));
	$(tabsContainer).attr('data-current-tab', currentTab + 1);
	//updateTotalCount();
	if(submitform) {
		let tabName = $(tabsContainer).find('.tabs-nav ul li.active a[data-tab]').attr('data-tab');
		if(tabName && $('[data-tab="'+tabName+'"]').find('form').length > 0) {
			$('[data-tab="'+tabName+'"]').find('form').submit();
		}
	}
	if (typeof window.bLazy?.revalidate === 'function') {
		window.bLazy.revalidate();
	}
	changeTabOrValueCallback(tabsContainer);
}

function changeTabOrValueCallback(tabsContainer) {
	let tabId = $(tabsContainer).find('.tabs-nav ul li.active a[data-tab]').attr('data-tab');
	let tabForm = $('.traveldata-section .tabs-container .tab-item[data-tab="'+tabId+'"]');
	let tabContent = $('.accommodationsearch.tabs-container .tab-item[data-tab="'+tabId+'"]');

	if($(tabForm).find('input[name*="[arrival]"]').val() !== '' && $(tabForm).find('input[name*="[departure]"]').val() !== '') {
		$(tabContent).addClass('withavailability');
		$('.accordion.pricerangewrapper').removeClass('d-none');
	} else {
		$(tabContent).removeClass('withavailability');
		$('.accordion.pricerangewrapper').addClass('d-none');
	}
}

function removeTabLabel(elem) {
	let tabsContainer = $(elem).closest('.tabs-container');
	if($(tabsContainer).find('.tabs-nav nav ul li').length < 2) {
		return;
	}

	let tabId = $(elem).find('[data-tab]').attr('data-tab');
	$(elem).remove();
	$(tabsContainer).find('.tab-item[data-tab="'+tabId+'"]').remove();

	if($(tabsContainer).find('.tabs-nav nav ul li.active').length === 0) {
		$(tabsContainer).find('.tabs-nav nav ul li:last-child a[data-tab]').click();
	}

	addRemoveLabelCallback(tabsContainer);
	changeTabCallback(tabsContainer, true);
}

function addTabLabel(containerElem) {
	let newTabNumber = $(containerElem).find('.tabs-nav nav ul li').length + 1;

	// label
	let htmlLabel = $(containerElem).find('#accosearchlabeldraft').html();
	htmlLabel = htmlLabel.replaceAll('data-tab="accommodation"', 'data-tab="accommodation'+newTabNumber+'"');
	htmlLabel = htmlLabel.replaceAll('<span class="num"></span>', '<span class="num">'+newTabNumber+'</span>');
	$(htmlLabel).appendTo($(containerElem).find('.tabs-nav nav ul'));

	// form
	let draft = '';
	try {
		draft = JSON.parse($('.accosearch-formDraft').html());
		draft = draft.html;
	} catch (e) {}
	let htmlForm = '<div class="tab-item" data-tab="accommodation' + newTabNumber + '">' + draft + '</div>';
	htmlForm = htmlForm.replaceAll('[{x}]', '['+(newTabNumber - 1)+']');
	htmlForm = htmlForm.replaceAll('{x}', (newTabNumber - 1));
	htmlForm = htmlForm.replaceAll('{y}', newTabNumber);
	let tabBefore = $(containerElem).find('.tabs-wrapper .tab-item').last();
	$(htmlForm).appendTo($(containerElem).find('.tabs-wrapper'));
	let newTab = $(containerElem).find('.tabs-wrapper .tab-item').last();
	const regex = /\[[0-9]+\]/;
	$(tabBefore).find('input, select').each(function() {
		let name = $(this).attr('name');
		if(typeof name === 'undefined') {
			return;
		}
		let value = $(this).val();
		name = name.replace(regex, '['+(newTabNumber - 1)+']');
		$(newTab).find('[name="'+name+'"]').val(value);
	});
	load($('[data-tab="accommodation'+newTabNumber+'"]'));
	searchload($('[data-tab="accommodation'+newTabNumber+'"]'));
	$(containerElem).find('.tabs-nav nav ul a[data-tab]').click();
	addRemoveLabelCallback(containerElem);
	changeTabCallback(containerElem, true);
}

function addRemoveLabelCallback(containerElem) {
	if($(containerElem).find('.tabs-nav ul:not(#accosearchlabeldraft) li').length >= parseInt($(containerElem).attr('data-max-tabs'))) {
		$(containerElem).find('.add').hide();
	} else {
		$(containerElem).find('.add').show();
	}
	let index = 0;
	$(containerElem).find('.tabs-wrapper .tab-item').each(function() {
		$(this).find('input, select').each(function() {
			let name = $(this).attr('name');
			if(name) {
				$(this).attr('name', name.replaceAll(/stay\[([0-9])+\]/g, 'stay['+index+']'));
			}
		});
		let attributes = ['data-passto', 'data-callback-arrival', 'data-callback-departure', 'data-id-arrival', 'data-id-departure', 'id', 'for'];
		attributes.forEach(attribute => {
			$(this).find('['+attribute+']').each(function() {
				let value = $(this).attr(attribute);
				if(value) {
					value = value.replaceAll(/stay\[([0-9])+\]/g, 'stay['+index+']');
					value = value.replaceAll(/\[([0-9])+\]/g, '['+index+']');
					value = value.replaceAll(/\\\[([0-9])+\\\]/g, '\\['+index+'\\]');
					$(this).attr(attribute, value);
				}
			});
		});
		/*
		$(this).find('[data-passto], [data-callback-arrival], [data-callback-departure], [data-id-arrival], [data-id-departure]').each(function() {
			let passTo = $(this).attr('data-passto');
			let callbackArrival = $(this).attr('data-callback-arrival');
			let callbackDeparture = $(this).attr('data-callback-departure');
			let arrival = $(this).attr('data-id-arrival');
			let departure = $(this).attr('data-id-departure');
			if(passTo) {
				$(this).attr('data-passto', passTo.replaceAll(/stay\[([0-9])+\]/g, 'stay['+index+']'));
			}
			if(callbackArrival) {
				$(this).attr('data-callback-arrival', callbackArrival.replaceAll(/\[([0-9])+\]/g, '['+index+']'));
			}
			if(callbackDeparture) {
				$(this).attr('data-callback-departure', callbackDeparture.replaceAll(/\[([0-9])+\]/g, '['+index+']'));
			}
			if(arrival) {
				$(this).attr('data-id-arrival', arrival.replaceAll(/\[([0-9])+\]/g, '['+index+']'));
			}
			if(departure) {
				$(this).attr('data-id-departure', departure.replaceAll(/\[([0-9])+\]/g, '['+index+']'));
			}
		});
		*/
		index++;
	});

	// todo: finish, this is not working preperly. Temporary solved with CSS
	/*
	index = 0;
	$(containerElem).find('.tabs-nav ul li a[data-tab]').each(function() {
		let tabName = $(this).attr('data-tab');
		if(tabName.indexOf('accommodation') === 0 && $(containerElem).find('.tabs-wrapper .tab-item[data-tab="' + tabName + '"]').length > 0) {
			// $('.tabs-wrapper .tab-item[data-tab="' + 'accommodation' + (index+1) + '"]').attr('data-tab', 'accommodationX');
			$(this).attr('data-tab', 'accommodation' + (index+1));
			$('.tabs-wrapper .tab-item[data-tab="' + tabName + '"]').attr('data-tab', 'accommodation' + (index+1));
		}
		index++;
	});
	*/
}

/* @todo: write function if needed */
function recalculateTabText() {
}

// Checkbox (custom)
//

// Group
function initCheckbox(elem) {
	if ($(elem).prop('checked')) {
		$(elem).parent('label').addClass('checked');
	}
}

// Callback
function customCheckboxCallback(elem) {
}

// Text collapse
//

function textCollapse(elem, box) {
	$(elem, box).each(function() {
		let elem = $(this);
		let node = elem.get(0);

		if (!$(elem).hasClass('init')) {
			$(elem).addClass('init');
		} else {
			$(elem).removeClass('collapsed');
		}

		let lineHeight = parseInt($(elem).css('line-height'));
		let minLineHeight = lineHeight * 10;
		let originalHeight = node ? node.scrollHeight : $(elem).innerHeight();
		$(elem).addClass('collapsed').css('--original-height', `${originalHeight}px`);
		let collapsedHeight = $(elem).innerHeight();

		if ((originalHeight - collapsedHeight) <= minLineHeight) {
			// Disable collapse for short texts
			$(elem).removeClass('init collapsed').css('--original-height', '');
			return;
		}

		// Keep collapsed state and add toggle
		let toggle = $(elem).next('.text-collapse-toggle');
		if (!toggle || toggle.length <= 0) {
			$('<a href="javascript:;" class="small text-collapse-toggle">' + strings.readmore[lang] + '</a>').insertAfter(elem).click(function(e) {
				if (!$(elem).hasClass('collapsed')) {
					$(elem).addClass('collapsed');
					$(this).text(strings.readmore[lang]);
				} else {
					$(elem).removeClass('collapsed');
					$(this).text(strings.readless[lang]);
				}

				scrollToElement($(elem).closest('.article'));
			});
		}
	});
}


// Recalc header min height
function recalcHeaderMinHeight() {
	let headerMinHeight = $('.headertop').last().outerHeight();
	if (typeof headerMinHeight !== 'undefined') {
		headerMinHeight = Math.floor(headerMinHeight);
		document.documentElement.style.setProperty('--header-min-height', `${headerMinHeight}px`);
	}
}

// Recalc header bottom height
function recalcHeaderBottomHeight() {
	let headerBottomHeight = $('#headerbottom').outerHeight();
	if (typeof headerBottomHeight !== 'undefined') {
		document.documentElement.style.setProperty('--header-bottom-height', `${headerBottomHeight}px`);
	}
}

// Read url params
function getURLParameter(url, name) {
	return (RegExp(name + '=' + '(.+?)(&|$)').exec(url)||[,null])[1];
}

// Formatter
// @todo: If used, speak with ARM because hes using it currently in the base client, ohtherwise delete function. exist also as es6 module
let Formatter = {
	formatPrice: function(amount) {
		let euroConverter = new Intl.NumberFormat('de-DE', {
			style: 'decimal',
			maximumFractionDigits: 0,
			minimumFractionDigits: 0,
		});
		amount = euroConverter.format(amount);

		return '€ ' + amount;
	},

	// date = 'Y-m-d' or something compatible with new Date();
	formatDate: function(date) {
		date  = new Date(date);
		return date.toLocaleDateString('de-DE', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			timeZone: 'UTC',
		});

		/*date = new Date(date);
		return addLeadingZero(date.getDay()) + '.' + addLeadingZero(date.getMonth() + 1) + '.' + date.getFullYear();*/
	},

	daysBetweenDates: function(date1, date2) {
		date1 = new Date(date1);
		date2 = new Date(date2);

		date1 = date1.getTime() / 1000;
		date2 = date2.getTime() / 1000;
		let days = (date2 - date1) / 86400;

		days = parseInt(days);
		if(days < 0) {
			days = 0;
		}
		return days;
	},

	/*addLeadingZero: function(number) {
	   number = parseInt(number);
	   if(number < 10) {
		  number = '0'+number;
	   }
	   return number+'';
	},*/
};

// Css calc
const CssCalc = (function () {
	let cache = {
		rem: null,
		vw: null,
		vh: null,
	};

	function updateCache() {
		cache.rem = compute('1rem');
		cache.vw  = compute('1vw');
		cache.vh  = compute('1vh');
	}

	function compute(expression) {
		const el = document.createElement('div');
		el.style.position = 'absolute';
		el.style.visibility = 'hidden';
		el.style.width = expression;
		document.body.appendChild(el);
		const value = el.offsetWidth;
		document.body.removeChild(el);
		return value; // immer als Number in px
	}

	return {
		toPx(expression) {
			// Direkter Cache-Zugriff
			if (expression === '1rem') return cache.rem ?? compute('1rem');
			if (expression === '1vw')  return cache.vw  ?? compute('1vw');
			if (expression === '1vh')  return cache.vh  ?? compute('1vh');

			// calc(), em, %, px usw. → direkt berechnen
			return compute(expression);
		},
		refresh() {
			updateCache();
		},
	};
})();

// Count up
function countUp(elem, countTo = 1, duration = 1500) {
	$({ countNum: $(elem).text()}).animate(
		{
			countNum: countTo,
		},
		{
			duration: duration,
			easing: 'linear',
			step: function() {
				$(elem).text(Math.floor(this.countNum));
			},
			complete: function() {
				$(elem).text(this.countNum);
			}
		}
	);
}

// Class change observer
function onClassChange($el, callback) {
	const observer = new MutationObserver(mutations => {
		mutations.forEach(mutation => {
			if (mutation.attributeName === 'class') {
				callback.call($el[0], $el);
			}
		});
	});

	observer.observe($el[0], { attributes: true });
	return observer;
}

// Slide switch
window.gridSlideSwitchReady = false;
function gridSlideSwitch(ready = false) {
	if (ready) {
		window.gridSlideSwitchReady = true;
	}

	if (window.gridSlideSwitchReady) {
		$('.grid-slide-switch').each(function () {
			const $container = $(this);
			const $items = $container.find('.grid-slide-switch-item');
			const totalDuration = 0.3; // seconds

			// Collect widths in a single pass and compute observedMinWidth from them
			const itemsArray = $items.toArray();
			const widths = itemsArray.map(function(el){
				const $child = $(el).children().first();
				if ($child.length) {
					// Use a temporary style to measure the intrinsic width (max-content)
					// This ensures that even flex containers return their full required width.
					const originalWidth = $child[0].style.width;
					const originalMaxWidth = $child[0].style.maxWidth;
					$child.css({
						'width': 'max-content',
						'max-width': 'none'
					});
					const iw = $child[0].getBoundingClientRect().width;
					$child.css({
						'width': originalWidth,
						'max-width': originalMaxWidth
					});
					return iw || 0;
				}
				return 0;
			});
			let observedMinWidth = 1920;
			if (widths.length) {
				observedMinWidth = Math.min.apply(null, [1920].concat(widths.filter(function(w){return w>=0;})));
			}

			$container.css({'--observed-min-width': observedMinWidth + 'px'}).addClass('init');

			// Apply per-item CSS custom properties (item width and proportional durations)
			for (let i = 0; i < itemsArray.length; i++) {
				const el = itemsArray[i];
				const iw = widths[i] || 0;
				if (iw) {
					$(el).css({'--item-width': iw + 'px'});
					$(el).children().first().css('width', iw + 'px');
				}
				const rightDist = observedMinWidth || 0;
				const widthDist = Math.max(iw - observedMinWidth, 0);
				const distSum = rightDist + widthDist;
				let rightDur = 0;
				let widthDur = 0;
				if (distSum > 0) {
					rightDur = totalDuration * (rightDist / distSum);
					widthDur = totalDuration * (widthDist / distSum);
				}
				$(el).css({
					'--right-transition-duration': rightDur + 's',
					'--max-width-transition-duration': widthDur + 's'
				});
			}
		});
	}
}


// Check passive support
//
function passiveSupport() {
	let supportsPassive = false;
	try {
		let opts = Object.defineProperty({}, 'passive', {
			get: function() {
				supportsPassive = true;
			}
		});
		window.addEventListener("testPassive", null, opts);
		window.removeEventListener("testPassive", null, opts);
	} catch (e) {}

	return supportsPassive;
}

// Cookies
//

// Get
function getCookie(cname) {
	try {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i <ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
	} catch(ex) {
		console.log(ex);
	}
	return "";
}

// Set
function setCookie(cname, cvalue, exdays) {
	var expires = '';
	if(exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		expires = "expires="+ d.toUTCString() + ";";
	}
	try {
		document.cookie = cname + "=" + cvalue + ";" + expires + "path=/";
	} catch(ex) {
		console.log(ex);
	}
}


// Wow book
window.wowBookCounter = 0;
window.wowBooks = [];
function initWowBook() {
	$('a[href*=".pdf"]').each(function() {
		if ($(this).attr('href').indexOf('valgardena.it') !== -1 && $(this).hasClass('wowbookinit') === false) {
			var linkhref = $(this).attr('href');
			if(linkhref.substr(linkhref.length - 4) === '.pdf') {
				$(this).addClass('wowbookbtn' + wowBookCounter).attr('data-wowbook', wowBookCounter);
				$('body').append('<div id="wowbook' + wowBookCounter + '"></div>');
				$(this).click(function(e) {
					var number = $(this).attr('data-wowbook');
					if($(this).hasClass('wowbookinit') === false) {
						$(this).addClass('wowbookinit');
						$('#wowbook' + number).wowBook({
							pdf: $('.wowbookbtn' + number).attr('href'),
							lightbox: '.wowbookbtn' + number,
							toolbar: 'first, back, next, last, zoomin, zoomout, slideshow, fullscreen, thumbnails',
							flipSound: false,
						});
						$('.wowbookbtn' + number).click();
					}
					e.preventDefault();
				});

				wowBooks[wowBooks.length] = wowBookCounter;
				wowBookCounter++;
			}
		}
	});
}

// Call init function
init();

// Expose globally used functions/objects on window to ensure module compatibility
(function assignGlobalsToWindow(){
	try {
		// Core utilities
		if (typeof detectEnviroment === 'function') window.detectEnviroment = window.detectEnviroment || detectEnviroment;
		if (typeof getScrollHeight === 'function') window.getScrollHeight = window.getScrollHeight || getScrollHeight;
		if (typeof getStickyTopHeight === 'function') window.getStickyTopHeight = window.getStickyTopHeight || getStickyTopHeight;
		if (typeof detectBreakpoint === 'function') window.detectBreakpoint = window.detectBreakpoint || detectBreakpoint;
		if (typeof bpIndex === 'function') window.bpIndex = window.bpIndex || bpIndex;
		if (typeof resize === 'function') window.resize = window.resize || resize;
		if (typeof scrollToElement === 'function') window.scrollToElement = window.scrollToElement || scrollToElement;

		// Galleries and sliders
		if (typeof getGalleryMode === 'function') window.getGalleryMode = window.getGalleryMode || getGalleryMode;
		if (typeof initSliderGallery === 'function') window.initSliderGallery = window.initSliderGallery || initSliderGallery;
		if (typeof destroySliderGallery === 'function') window.destroySliderGallery = window.destroySliderGallery || destroySliderGallery;

		// Tabs
		if (typeof initTabs === 'function') window.initTabs = window.initTabs || initTabs;
		if (typeof initTabNavigationSlider === 'function') window.initTabNavigationSlider = window.initTabNavigationSlider || initTabNavigationSlider;
		if (typeof changeTab === 'function') window.changeTab = window.changeTab || changeTab;
		if (typeof changeTabCallback === 'function') window.changeTabCallback = window.changeTabCallback || changeTabCallback;
		if (typeof changeTabOrValueCallback === 'function') window.changeTabOrValueCallback = window.changeTabOrValueCallback || changeTabOrValueCallback;
		if (typeof removeTabLabel === 'function') window.removeTabLabel = window.removeTabLabel || removeTabLabel;
		if (typeof addTabLabel === 'function') window.addTabLabel = window.addTabLabel || addTabLabel;
		if (typeof addRemoveLabelCallback === 'function') window.addRemoveLabelCallback = window.addRemoveLabelCallback || addRemoveLabelCallback;
		if (typeof recalculateTabText === 'function') window.recalculateTabText = window.recalculateTabText || recalculateTabText;

		// Helpers
		if (typeof countUp === 'function') window.countUp = window.countUp || countUp;
		if (typeof onClassChange === 'function') window.onClassChange = window.onClassChange || onClassChange;
		if (typeof passiveSupport === 'function') window.passiveSupport = window.passiveSupport || passiveSupport;
		if (typeof CssCalc !== 'undefined') window.CssCalc = window.CssCalc || CssCalc;

		// Menus (used by markup and event handlers)
		if (typeof openMenu === 'function') window.openMenu = window.openMenu || openMenu;
		if (typeof closeMenu === 'function') window.closeMenu = window.closeMenu || closeMenu;
		if (typeof closeAllMainNavItems === 'function') window.closeAllMainNavItems = window.closeAllMainNavItems || closeAllMainNavItems;
		if (typeof closeFullscreenMenu === 'function') window.closeFullscreenMenu = window.closeFullscreenMenu || closeFullscreenMenu;
		if (typeof openFullscreenMenu === 'function') window.openFullscreenMenu = window.openFullscreenMenu || openFullscreenMenu;

		if (typeof initWowBook === 'function') window.initWowBook = window.initWowBook || initWowBook;

		// Init entry
		if (typeof init === 'function') window.init = window.init || init;

		// Load entry
		if (typeof init === 'function') window.load = window.load || load;
	} catch (e) {
		// Fail silently; exposing helpers should never break runtime
	}
})();
